import {
  IonButton,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonLabel,
  IonModal,
  IonPage,
  IonRow,
} from "@ionic/react";
import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import PatientSlider from "../components/PatientSlider";
import TopLeftUserName from "../components/TopLeftUserName";
import { PatientVM } from "../models/PatientVM";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  createPatientStep2State,
  currentAssessmentState,
  defaultAssessment,
  dummyDropDowns,
  isDuplicateCalledState,
  networkConnectionStatus,
  newAllDropDownState,
  PatientState,
  loggedInUserState,
} from "../data/atoms";
import { ActionType, ConversionRequired, TestType } from "../models/Enums";
import {
  EnableDisablePatientRtm,
  GetPatientById,
  GetRtmPatientEducationStatus,
  GetTrendlineGraph,
} from "../services/AuthServices";
import { SearchPatientVisitDetails } from "../services/AssessmentsService";
import { PatientVisitSummary } from "../models/PatientVisitSummary";
import Loader from "../components/LoaderComponent";
import {
  convertDOBintoAge,
  convertUnit,
  formatDate,
  convertISOToReadableDate,
  localDateTime,
  utcToLocalDate,
  safeFormatDate,
  toValidDate,
} from "../utils/sharedFunction";
import { GetGaitFallRisk } from "../models/AssessmentRelated/Gait";
import TrendlineGraph from "../components/Graphs/TrendlineGraph";
import TrendLineGraphSvg from "../components/Graphs/TrendLineGraphSvg";
import AssessmentInfoTable from "./assessment-info-table";
import { AssessmentMetric } from "../models/Option";
import CustomFloatingBarGraph from "../components/Graphs/CustomFloatingBarGraph";
import CompletedEducationModal from "../components/modals/completed-education-modal";
import RemoteTherapeuticMonitoringModal from "../components/modals/remote-therapeutic-monitoring-modal";
import RtmEnabledModal from "../components/modals/rtm-enabled-modal";
import PatientExistModal from "../components/modals/patient-exist-modal";
import ConsentFormModal from "../components/modals/consent-form-modal";
import SetupEpisodeModal from "../components/modals/setup-episode-modal";
import ProactiveYouModal from "../components/modals/ProactiveYouModal";
import PatientRegistrationQRModal from "../components/modals/patient-registeration-qr-modal";
import ErrorTopToaster from "../components/ErrorTopToaster";
import ChooseEpisodeModal from "../components/modals/choose-episode-modal";
import NewEpisodeModal from "../components/modals/new-episode-modal";

interface Props {
  props: any;
}

const PatientPage: React.FC<Props> = ({ props }) => {
  let history = useHistory();
  const [patientInfo, setpatientInfo] = useRecoilState(PatientState);
  const [newAllDropDown, setNewAllDropDown] =
    useRecoilState(newAllDropDownState);
  const [patientAge, setpatientAge] = useState(0);
  const [createPatientStep2, setCreatePatientStep2] = useRecoilState(
    createPatientStep2State,
  );
  const [patientLastTestLookupId, setPatientLastTestLookupId] = useState(0);
  const [patientDetails, setPatientDetails] = useState<PatientVM>(patientInfo);
  const [loggedInUser, setLoggedInUser] = useRecoilState(loggedInUserState);
  const [patientDetailsRecoil, setPatientDetailsRecoil] =
    useRecoilState(PatientState);
  const [currentFallRisk, setCurrentFallRisk] = useState<any>();
  const [isSummariesLoaded, setIsSummariesLoaded] = useState<boolean>(false);
  const [patientVisitsCount, setPatientVisitsCount] = useState<any>();
  const [loading, setLoading] = useState(false);
  const [selectedGaitIndex, setGaitSelectedIndex] = useState(0);
  const [selected5xIndex, set5xSelectedIndex] = useState(0);
  const [selectedRLGLIndex, setRLGLSelectedIndex] = useState(0);
  const [selectedAROMIndex, setAROMSelectedIndex] = useState(0);
  const [selectedBalloonPopperIndex, setBalloonPopperSelectedIndex] =
    useState(0);
  const [selectedAppleFrenzyIndex, setAppleFrenzySelectedIndex] = useState(0);
  const [selectedVeggieSlicerIndex, setVeggieSlicerSelectedIndex] = useState(0);
  const [selectedTugIndex, setTugSelectedIndex] = useState(0);
  const [selectedFunctionalReachIndex, setFunctionalReachSelectedIndex] =
    useState(0);
  const [selectedMctsibIndex, setMctsibSelectedIndex] = useState(0);
  const [isGaitClicked, setIsGaitClicked] = useState(false);
  const [is5xclicked, setIs5xClicked] = useState(false);
  const [isRLGLClicked, setIsRLGLClicked] = useState(false);
  const [isAROMClicked, setIsAROMClicked] = useState(false);
  const [isBalloonPopperClicked, setIsBalloonPopperClicked] = useState(false);
  const [isAppleFrenzyClicked, setIsAppleFrenzyClicked] = useState(false);
  const [isVeggieSlicerClicked, setIsVeggieSlicerClicked] = useState(false);
  const [isTugClicked, setIsTugClicked] = useState(false);
  const [isFunctionalReachClicked, setIsFunctionalReachClicked] =
    useState(false);
  const [days, setDays] = useState(0);
  const [GaitGraphValuesForReport, setGaitGraphValuesForReport] = useState<any>(
    [],
  );
  const [XGraphValuesForReport, set5XGraphValuesForReport] = useState<any>([]);
  const [aromGraphValuesForReport, setAromGraphValuesForReport] = useState<any>(
    [],
  );
  const [rlglGraphValuesForReport, setRlglGraphValuesForReport] = useState<any>(
    [],
  );
  const [
    balloonPopperGraphValuesForReport,
    setBalloonPopperGraphValuesForReport,
  ] = useState<any>([]);
  const [appleFrenzyGraphValuesForReport, setAppleFrenzyGraphValuesForReport] =
    useState<any>([]);
  const [
    veggieSlicerGraphValuesForReport,
    setVeggieSlicerGraphValuesForReport,
  ] = useState<any>([]);
  const [tugGraphValuesForReport, setTugGraphValuesForReport] = useState<any>(
    [],
  );
  const [isIncompleteTugAssessment, setIsIncompleteTugAssessment] =
    useState<boolean>(false);
  const [
    functionalReachGraphValuesForReport,
    setFunctionalReachGraphValuesForReport,
  ] = useState<any>([]);

  const [mctsibGraphValuesForReport, setMctsibGraphValuesForReport] =
    useState<any>([]);
  const [trendlinePlotGaitData, setTrendlinePlotGaitData] = useState<any>({
    gaitGraphData: [],
    gaitTableData: [],
    gaitGraphValuesForReport: [],
  });
  const [trendlinePlotRLGLData, setTrendlinePlotRLGLData] = useState<any>({
    rlglGraphData: [],
    rlglTableData: [],
    rlglGraphValuesForReport: [],
  });
  const [trendlinePlotAROMData, setTrendlinePlotAROMData] = useState<any>({
    aromGraphData: [],
    aromTableData: [],
    aromGraphValuesForReport: [],
  });
  const [trendlinePlot5xData, setTrendlinePlot5xData] = useState<any>({
    sitStandGraphData: [],
    sitStandTableData: [],
    sitStandGraphValuesForReport: [],
  });
  const [trendlinePlotBalloonPopperData, setTrendlinePlotBalloonPopperData] =
    useState<any>({
      balloonPopperGraphData: [],
      balloonPopperTableData: [],
      balloonPopperGraphValuesForReport: [],
    });
  const [trendlinePlotAppleFrenzyData, setTrendlinePlotAppleFrenzyData] =
    useState<any>({
      appleFrenzyGraphData: [],
      appleFrenzyTableData: [],
      appleFrenzyGraphValuesForReport: [],
    });
  const [trendlinePlotVeggieSlicerData, setTrendlinePlotVeggieSlicerData] =
    useState<any>({
      veggieSlicerGraphData: [],
      veggieSlicerTableData: [],
      veggieSlicerGraphValuesForReport: [],
    });
  const [trendlinePlotMctsibData, setTrendlinePlotMctsibData] = useState<any>({
    mctsibGraphData: [],
    mctsibTableData: [],
    mctsibGraphValuesForReport: [],
  });
  const [
    trendlinePlotFunctionalReachData,
    setTrendlinePlotFunctionalReachData,
  ] = useState<any>({
    functionalReachGraphData: [],
    functionalReachTableData: [],
    functionalReachGraphValuesForReport: [],
  });
  const [trendlinePlotTugData, setTrendlinePlotTugData] = useState<any>({
    tugGraphData: [],
    tugTableData: [],
    tugGraphValuesForReport: [],
  });
  const [yMappings, setYMappings] = useState<Record<number, string> | null>(
    null,
  );

  const [currentMetric, setCurrentMetric] = useState<number>(1);

  const [patientSummariesList, setPatientSummariesList] = useState<
    PatientVisitSummary[]
  >([]);
  const [isAlreadyClicked, setIsAlreadyClicked] = useState(false);
  const [lastAssessmentSummary, setLastAssessmentSummary] =
    useState<PatientVisitSummary>();

  let patientToEdit: PatientVM = useRecoilValue(PatientState);
  const [patientInformation, setPatientInformation] = useState<PatientVM>();
  const [ShowNetWorkRecoil, setShowNetWorkRecoil] = useRecoilState(
    networkConnectionStatus,
  );

  const [isDuplicateCalled, setIsDuplicateCalled] = useRecoilState(
    isDuplicateCalledState,
  );
  const elementRef = useRef(null);
  const [isGaitGraphSet, setIsGaitGraphSet] = useState(false);
  const [is5xGraphSet, setIs5xGraphSet] = useState(false);
  const [isAROMGraphSet, setIsAROMGraphSet] = useState(false);
  const [isRLGLGraphSet, setIsRLGLGraphSet] = useState(false);
  const [isBalloonPopperGraphSet, setIsBalloonPopperGraphSet] = useState(false);
  const [isAppleFrenzyGraphSet, setIsAppleFrenzyGraphSet] = useState(false);
  const [isVeggieSlicerGraphSet, setIsVeggieSlicerGraphSet] = useState(false);
  const [isTugGraphSet, setIsTugGraphSet] = useState(false);
  const [isFunctionalReachGraphSet, setIsFunctionalReachGraphSet] =
    useState(false);
  const [isMctsibGraphSet, setIsMctsibGraphSet] = useState(false);
  const [currentAssessment, setcurrentAssessmentState] = useRecoilState(
    currentAssessmentState,
  );
  const [activeTab, setActiveTab] = useState("lean");
  const [CompletedEducation, setCompletedEducation] = useState(false);
  const [isRtmConfigurationEnabled, setIsRtmConfigurationEnabled] =
    useState(false);
  const rtmEnabledRef = useRef(false);
  const [RemoteTherapeuticMonitoring, setRemoteTherapeuticMonitoring] =
    useState(false);
  const [ConsentForm, setConsentForm] = useState(false);
  const [SetupEpisode, setSetupEpisode] = useState(false);
  const [ChooseEpisode, setChooseEpisode] = useState(false);
  const [NewEpisode, setNewEpisode] = useState(false);
  // RTM State
  const [IsNewEpisode, setIsNewEpisode] = useState(false);
  const [IsRtmReenable, setIsRtmReenable] = useState(false);
  const [RtmEnabled, setRtmEnabled] = useState(false);
  const [openRtmModal, setOpenRtmModal] = useState(false);
  const [consentFormData, setConsentFormData] = useState<any>(null);
  const [proactiveYouModal, setProactiveYouModal] = useState(false);
  const [openProactiveAfterClose, setOpenProactiveAfterClose] = useState(false);

  const [registerPatientModal, setRegisterPatientModal] = useState(false);
  const [patientNotExistModal, setPatientNotExistModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  // Clear error message after 5 seconds
  useEffect(() => {
    if (errorMessage) {
      const timer = setTimeout(() => {
        setErrorMessage("");
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [errorMessage]);

  function goToEditPatient() {
    localStorage.setItem(
      "fullName",
      patientToEdit!.firstName + " " + patientToEdit!.lastName,
    );
    setCreatePatientStep2(false);
    history.push("/patient-profile", { props: true });
  }

  async function GetPatientVisitDetails() {
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    try {
      await SearchPatientVisitDetails({
        PatientId: Number(localStorage.getItem("patientServerID")!),
        EncryptedServerId: localStorage.getItem("EncryptedServerId"),
      }).then(async (res: any) => {
        // clearing patientGraphId from localstorage to avoid call of previous patient to get graph data
        localStorage.removeItem("patientGraphId");

        // if (res?.data?.patientInfo) {
        //   res.data.patientInfo.rtmStartDate = utcToLocalDate(
        //     res.data.patientInfo.rtmStartDate,
        //   );
        // }

        localStorage.setItem(
          "patientMobileNumber",
          res?.data?.patientInfo?.mobilePhone,
        );

        const isSFTPPatient =
          res?.data?.patientInfo?.externalPatientId !== 0 ? "true" : "false";
        localStorage.setItem("isSFTPPatient", isSFTPPatient);

        // Any of these collections can come back null/absent from the API, so
        // normalize before touching .length / .sort / index access.
        const lastVisitData: any[] = res?.data?.lstPatientLastVisitDataVM ?? [];
        const metrics: any[] = res?.data?.assessmentMetrics ?? [];

        if (lastVisitData.length > 0) {
          localStorage.setItem(
            "patientGraphId",
            lastVisitData[0]?.patientId,
          );
        }
        if (metrics.length > 0) {
          setAssessmentMetrics(metrics);
        }
        setPatientSummariesList([
          ...lastVisitData.sort(function (a: any, b: any) {
            return (
              (toValidDate(b?.visitDate)?.getTime() ?? 0) -
              (toValidDate(a?.visitDate)?.getTime() ?? 0)
            );
          }),
        ]);

        // Find the element where vbTestLookupId is not equal to TestType.red_light_green_light
        const lastAssessment = res?.data?.latestAssesment;

        console.log("lastAssessment: ", lastAssessment);

        localStorage.setItem(
          "masterUserId",
          res?.data?.patientInfo?.masterUserId || "",
        );

        // Set the found element to setLastAssessmentSummary
        setLastAssessmentSummary(lastAssessment);
        setCurrentFallRisk({ ...(res?.data?.patientMobilityValues?.[0] ?? {}) });
        setPatientVisitsCount([...(res?.data?.patientVisitsCount ?? [])]);
        setPatientInformation({ ...res?.data?.patientInfo });
        setpatientInfo((prevState: PatientVM) => ({
          ...prevState,
          ...res?.data?.patientInfo,
          referralId: res?.data?.patientInfo?.referralSourceId,
        }));
        const patientDob = toValidDate(res?.data?.patientInfo?.dob);
        setpatientAge(patientDob ? convertDOBintoAge(patientDob) : 0);
        if (lastVisitData.length > 0) {
          setPatientLastTestLookupId(lastVisitData[0]?.vbTestLookupId);
        }

        sessionStorage.setItem(
          "patientDetails",
          JSON.stringify({ ...res?.data?.patientInfo }),
        );

        lastVisitData.filter((patientData: any) => {
          return (res?.data?.patientMobilityValues ?? []).some(
            (mobValue: any) => {
              if (patientData?.id === mobValue?.id) {
                return patientData;
              }
              return null;
            },
          );
        });

        const lastAssessmentDate = toValidDate(lastAssessment?.visitDate);
        if (lastAssessmentDate) {
          let lastAssessmentTime = lastAssessmentDate.getTime();
          let currentDayTime = new Date().getTime();

          let difference = Math.round(
            (currentDayTime - lastAssessmentTime) / (1000 * 60 * 60 * 24),
          );
          setDays(difference);
        } else {
          setDays(0);
        }

        if (res) {
          setLoading(true);
        }
        setIsSummariesLoaded(true);

        console.log("rtmEnabledRef.current", rtmEnabledRef.current);
        console.log(
          "patientDetails?.isPatientRTMEnabled",
          res?.data?.patientInfo?.isPatientRTMEnabled,
        );
        console.log(
          "res?.data?.patientInfo?.isEverEducated",
          res?.data?.patientInfo?.isEverEducated,
        );

        //Skip education modal for select business only
        if (
          rtmEnabledRef.current &&
          res?.data?.patientInfo?.isPatientRTMEnabled &&
          !res?.data?.patientInfo?.isSFTPPatient &&
          false
        ) {
          try {
            const response: any = await GetRtmPatientEducationStatus({
              PatientId: localStorage.getItem("patientServerID"),
              EncryptedServerId: localStorage.getItem("EncryptedServerId"),
            });

            console.log("response", response);

            if (!response?.data) {
              setTimeout(() => {
                setCompletedEducation(true);
              }, 200);
            }
          } catch (error) {
            history.push("/confirmation", {
              actionType: ActionType.FailureAPIResponse,
            });
            console.error(error);
          }
        }

        const gaitAssessment = new AssessmentMetric();
        gaitAssessment.id = 1;
        gaitAssessment.lookupTypeId = TestType.gait;
        gaitAssessment.name = "Gait Speed";
        selectDropdownItem(gaitAssessment);
      });
    } catch (error) {
      history.push("/confirmation", {
        actionType: ActionType.FailureAPIResponse,
      });
      console.error(error);
    }
  }

  async function GetPatientDetails() {
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    try {
      await GetPatientById({
        PatientId: localStorage.getItem("patientServerID"),
        EncryptedServerId: localStorage.getItem("EncryptedServerId"),
      }).then(async function (response: any) {
        setIsAlreadyClicked(false);
        if (
          response.data.responseCode !== 0 &&
          Number(response?.data?.patientVM?.id) === -1
        ) {
          setPatientNotExistModal(true);
          return;
        }
        if (
          response.data.responseCode !== 0 &&
          Number(response?.data?.patientVM?.id) > 0
        ) {
          // if (response?.data?.patientVM) {
          //   response.data.patientVM.rtmStartDate = utcToLocalDate(
          //     response.data.patientVM.rtmStartDate,
          //   );
          // }

          localStorage.setItem(
            "patientServerID",
            response?.data?.patientVM?.id,
          );
          setNewAllDropDown(dummyDropDowns);
          setpatientInfo((prevState: PatientVM) => ({
            ...prevState,
            ...response.data.patientVM,
            referralId: response.data.patientVM.referralSourceId,
          }));
          setPatientDetails(response.data.patientVM);
          setpatientAge(
            convertDOBintoAge(new Date(response.data.patientVM.dob)),
          );
          goToEditPatient();
        }
      });
    } catch (error) {
      history.push("/confirmation", {
        actionType: ActionType.FailureAPIResponse,
      });
      console.error(error);
    }
  }

  async function SetGraphTableDataForGait(
    response: any,
    vbTestId: number,
    metricFilter: number,
  ) {
    let graphObj: any = {
      lineGraphValues: [],
      RangeIds: [],
      PatientIds: [],
      VBTestIds: [],
    };

    console.log("metric filter: ", metricFilter);

    response?.data?.dashboardPatientTestResponse.sort((a: any, b: any) => {
      // Convert TestDate values to Date objects for proper comparison
      const dateA: Date = new Date(a.TestDate);
      const dateB: Date = new Date(b.TestDate);

      // Compare the dates
      return dateA.getTime() - dateB.getTime();
    });

    if (metricFilter === 1) {
      try {
        (response?.data?.dashboardPatientTestResponse ?? []).map((data: any) => {
          console.log("test date: ", data.testDate);
          graphObj.lineGraphValues.push(data.calculatedValue);
          graphObj.RangeIds.push(formatDate(data.testDate));
          graphObj.PatientIds.push(data.patientId);
          graphObj.VBTestIds.push(data.vbTestId);
        });
      } catch (ex: any) {
        console.log(ex);
      }
    } else if (metricFilter === 2) {
      try {
        (response?.data?.dashboardPatientTestResponse ?? []).map((data: any) => {
          let mobility;
          switch (data.mobility) {
            case "ultralow":
              mobility = 1;
              break;
            case "low":
              mobility = 1;
              break;
            case "medium":
              mobility = 2;
              break;
            case "high":
              mobility = 3;
              break;
          }
          graphObj.lineGraphValues.push(mobility);
          graphObj.RangeIds.push(formatDate(data.testDate));
          graphObj.PatientIds.push(data.patientId);
          graphObj.VBTestIds.push(data.vbTestId);
        });

        setYMappings({
          1: "Low",
          2: "Med",
          3: "High",
        });
      } catch (ex: any) {
        console.log(ex);
      }
    }

    let assesmmentForTable = response?.data?.dashboardPatientTestResponse?.find(
      (data: any) => data.vbTestId === vbTestId,
    );

    console.log(
      "dashboardPatientTestResponse: ",
      response?.data?.dashboardPatientTestResponse?.slice(-1)[0],
    );

    setGaitGraphValuesForReport(
      assesmmentForTable === undefined
        ? response?.data?.dashboardPatientTestResponse?.slice(-1)[0]
        : assesmmentForTable,
    );

    setTrendlinePlotGaitData(() => ({
      gaitGraphData: graphObj,
      gaitTableData: response?.data?.tables,
      gaitGraphValuesForReport:
        assesmmentForTable === undefined
          ? response?.data?.dashboardPatientTestResponse[0]
          : assesmmentForTable,
    }));
    setIsGaitGraphSet(true);

    console.log("trendlinePlotData: ", graphObj);
    console.log("assesmmentForTable: ", assesmmentForTable);
  }

  async function SetGraphTableDataFor5XSTS(
    response: any,
    vbTestId: number,
    metricFilter: number,
  ) {
    let graphObj: any = {
      lineGraphValues: [],
      RangeIds: [],
      PatientIds: [],
      VBTestIds: [],
    };

    response?.data?.dashboardPatientTestResponse.sort((a: any, b: any) => {
      // Convert TestDate values to Date objects for proper comparison
      const dateA: Date = new Date(a.TestDate);
      const dateB: Date = new Date(b.TestDate);

      // Compare the dates
      return dateA.getTime() - dateB.getTime();
    });

    try {
      (response?.data?.dashboardPatientTestResponse ?? []).map((data: any) => {
        graphObj.lineGraphValues.push(data.calculatedValue);
        graphObj.RangeIds.push(formatDate(data.testDate));
        graphObj.PatientIds.push(data.patientId);
        graphObj.VBTestIds.push(data.vbTestId);
      });
    } catch (ex: any) {
      console.log(ex);
    }

    if ((response?.data?.tables?.[0]?.rows?.length ?? 0) > 0) {
      let i = 1;
      response?.data?.tables?.[0]?.rows?.slice(1, -1).map((r: any) => {
        if (r.Measure) {
          r.Measure = "Rep " + i + " (sec)";
        }
        i++;
      });
      response?.data?.tables?.[0]?.rows?.slice(-1).map((r: any) => {
        r.Measure = "Total Time (sec)";
      });
    }
    let assesmmentForTable = response?.data?.dashboardPatientTestResponse?.find(
      (data: any) => data.vbTestId == vbTestId,
    );

    console.log(
      "dashboardPatientTestResponse: ",
      response?.data?.dashboardPatientTestResponse?.slice(-1)[0],
    );

    set5XGraphValuesForReport(
      assesmmentForTable === undefined
        ? response?.data?.dashboardPatientTestResponse?.slice(-1)[0]
        : assesmmentForTable,
    );

    setTrendlinePlot5xData(() => ({
      sitStandGraphData: graphObj,
      sitStandTableData: response?.data?.tables,
      sitStandGraphValuesForReport:
        assesmmentForTable === undefined
          ? response?.data?.dashboardPatientTestResponse[0]
          : assesmmentForTable,
    }));
    setIs5xGraphSet(true);

    console.log("trendlinePlotData: ", graphObj);
    console.log("assesmmentForTable: ", assesmmentForTable);
  }

  async function SetGraphTableDataForUpperBodyAROM(
    response: any,
    vbTestId: number,
    metricFilter: number,
  ) {
    let graphObj: any = {
      lineGraphValues: [],
      RangeIds: [],
      PatientIds: [],
      VBTestIds: [],
    };

    response?.data?.upperBodyAROMTrendlineGraphData.sort((a: any, b: any) => {
      // Convert TestDate values to Date objects for proper comparison
      const dateA: Date = new Date(a.TestDate);
      const dateB: Date = new Date(b.TestDate);

      // Compare the dates
      return dateA.getTime() - dateB.getTime();
    });

    // Separate into left and right arrays
    const leftData = [];
    const rightData = [];

    // Organize data into left and right arrays
    for (const item of response?.data?.upperBodyAROMTrendlineGraphData) {
      if (item.property.includes("Left")) {
        leftData.push(item);
      } else if (item.property.includes("Right")) {
        rightData.push(item);
      }
    }

    // Group by testDate and sort by Adduction first, then Abduction
    const groupAndSort = (data: any) => {
      const grouped = data.reduce((acc: any, item: any) => {
        const formattedDate = formatDate(item.testDate); // Apply formatDate here
        if (!acc[formattedDate]) acc[formattedDate] = [];
        acc[formattedDate].push(item);
        return acc;
      }, {});

      const sortedData = [];
      const testDates = Object.keys(grouped);

      for (const group of Object.values(grouped) as any) {
        sortedData.push(
          group
            .sort((a: any, b: any) => {
              if (a.property.includes("Adduction")) return -1;
              if (b.property.includes("Abduction")) return 1;
              return 0;
            })
            .map((item: any) => parseInt(item.calculatedValue, 10)),
        );
      }

      return { sortedData, testDates };
    };

    const { sortedData: sortedLeft, testDates } = groupAndSort(leftData);
    const { sortedData: sortedRight } = groupAndSort(rightData);

    console.log("Left Data:", sortedLeft);
    console.log("Right Data:", sortedRight);
    console.log("Test Dates:", testDates);

    try {
      (response?.data?.upperBodyAROMTrendlineGraphData ?? []).map((data: any) => {
        graphObj.PatientIds.push(data.patientId);
        graphObj.VBTestIds.push(data.vbTestId);
      });

      graphObj.lineGraphValues = [sortedLeft, sortedRight];
      graphObj.RangeIds = testDates;
    } catch (ex: any) {
      console.log(ex);
    }

    let assesmmentForTable =
      response?.data?.upperBodyAROMTrendlineGraphData.find(
        (data: any) => data.vbTestId == vbTestId,
      );

    console.log(
      "dashboardPatientTestResponse: ",
      response?.data?.upperBodyAROMTrendlineGraphData?.slice(-1)[0],
    );

    setAromGraphValuesForReport(
      assesmmentForTable === undefined
        ? response?.data?.upperBodyAROMTrendlineGraphData?.slice(-1)[0]
        : assesmmentForTable,
    );

    setTrendlinePlotAROMData(() => ({
      aromGraphData: graphObj,
      aromTableData: response?.data?.tables,
      aromGraphValuesForReport:
        assesmmentForTable === undefined
          ? response?.data?.upperBodyAROMTrendlineGraphData[0]
          : assesmmentForTable,
    }));
    setIsAROMGraphSet(true);

    console.log("trendlinePlotData: ", graphObj);
    console.log("assesmmentForTable: ", assesmmentForTable);
  }

  async function SetGraphTableDataForRLGL(
    response: any,
    vbTestId: number,
    metricFilter: number,
  ) {
    let graphObj: any = {
      lineGraphValues: [],
      RangeIds: [],
      PatientIds: [],
      VBTestIds: [],
    };

    response?.data?.dashboardPatientTestResponse.sort((a: any, b: any) => {
      // Convert TestDate values to Date objects for proper comparison
      const dateA: Date = new Date(a.TestDate);
      const dateB: Date = new Date(b.TestDate);

      // Compare the dates
      return dateA.getTime() - dateB.getTime();
    });

    try {
      (response?.data?.dashboardPatientTestResponse ?? []).map((data: any) => {
        graphObj.lineGraphValues.push(data.calculatedValue);
        graphObj.RangeIds.push(formatDate(data.testDate));
        graphObj.PatientIds.push(data.patientId);
        graphObj.VBTestIds.push(data.vbTestId);
      });
    } catch (ex: any) {
      console.log(ex);
    }

    let assesmmentForTable = response?.data?.dashboardPatientTestResponse?.find(
      (data: any) => data.vbTestId == vbTestId,
    );

    console.log(
      "dashboardPatientTestResponse: ",
      response?.data?.dashboardPatientTestResponse?.slice(-1)[0],
    );

    setRlglGraphValuesForReport(
      assesmmentForTable === undefined
        ? response?.data?.dashboardPatientTestResponse?.slice(-1)[0]
        : assesmmentForTable,
    );

    setTrendlinePlotRLGLData(() => ({
      rlglGraphData: graphObj,
      rlglTableData: response?.data?.tables,
      rlglGraphValuesForReport:
        assesmmentForTable === undefined
          ? response?.data?.dashboardPatientTestResponse[0]
          : assesmmentForTable,
    }));
    setIsRLGLGraphSet(true);

    console.log("trendlinePlotData: ", graphObj);
    console.log("assesmmentForTable: ", assesmmentForTable);
  }

  async function SetGraphTableDataForBalloonPopper(
    response: any,
    vbTestId: number,
    metricFilter: number,
  ) {
    let graphObj: any = {
      lineGraphValues: [],
      RangeIds: [],
      PatientIds: [],
      VBTestIds: [],
    };

    console.log("metric filter: ", metricFilter);

    // First sort by date and then by property
    response?.data?.balloonPopperTrendlineGraphData?.sort((a: any, b: any) => {
      // First sort by date
      const dateCompare =
        new Date(a.testDate).getTime() - new Date(b.testDate).getTime();

      if (dateCompare === 0) {
        // If dates are same, sort by property (balloonsHitPerMinute first)
        if (a.property === "balloonsHitPerMinute") return -1;
        if (b.property === "balloonsMissedPerMinute") return 1;
        return 0;
      }

      return dateCompare;
    });

    try {
      response?.data?.balloonPopperTrendlineGraphData?.map((data: any) => {
        graphObj.lineGraphValues.push(data.calculatedValue);
        graphObj.RangeIds.push(formatDate(data.testDate));
        graphObj.PatientIds.push(data.patientId);
        graphObj.VBTestIds.push(data.vbTestId);
      });
    } catch (ex: any) {
      console.log(ex);
    }

    let assesmmentForTable =
      response?.data?.balloonPopperTrendlineGraphData.find(
        (data: any) => data.vbTestId === vbTestId,
      );

    console.log(
      "dashboardPatientTestResponse: ",
      response?.data?.balloonPopperTrendlineGraphData?.slice(-1)[0],
    );

    setBalloonPopperGraphValuesForReport(
      assesmmentForTable === undefined
        ? response?.data?.balloonPopperTrendlineGraphData?.slice(-1)[0]
        : assesmmentForTable,
    );

    setTrendlinePlotBalloonPopperData(() => ({
      balloonPopperGraphData: graphObj,
      balloonPopperTableData: response?.data?.tables,
      balloonPopperGraphValuesForReport:
        assesmmentForTable === undefined
          ? response?.data?.balloonPopperTrendlineGraphData[0]
          : assesmmentForTable,
    }));
    setIsBalloonPopperGraphSet(true);

    console.log("trendlinePlotData: ", graphObj);
    console.log("assesmmentForTable: ", assesmmentForTable);
  }

  async function SetGraphTableDataForVeggieSlicer(
    response: any,
    vbTestId: number,
    metricFilter: number,
  ) {
    let graphObj: any = {
      lineGraphValues: [],
      RangeIds: [],
      PatientIds: [],
      VBTestIds: [],
    };

    console.log("metric filter: ", metricFilter);

    response?.data?.dashboardPatientTestResponse.sort((a: any, b: any) => {
      // Convert TestDate values to Date objects for proper comparison
      const dateA: Date = new Date(a.TestDate);
      const dateB: Date = new Date(b.TestDate);

      // Compare the dates
      return dateA.getTime() - dateB.getTime();
    });

    try {
      (response?.data?.dashboardPatientTestResponse ?? []).map((data: any) => {
        graphObj.lineGraphValues.push(data.calculatedValue);
        graphObj.RangeIds.push(formatDate(data.testDate));
        graphObj.PatientIds.push(data.patientId);
        graphObj.VBTestIds.push(data.vbTestId);
      });
    } catch (ex: any) {
      console.log(ex);
    }

    let assesmmentForTable = response?.data?.dashboardPatientTestResponse?.find(
      (data: any) => data.vbTestId === vbTestId,
    );

    console.log(
      "dashboardPatientTestResponse: ",
      response?.data?.dashboardPatientTestResponse?.slice(-1)[0],
    );

    setVeggieSlicerGraphValuesForReport(
      assesmmentForTable === undefined
        ? response?.data?.dashboardPatientTestResponse?.slice(-1)[0]
        : assesmmentForTable,
    );

    setTrendlinePlotVeggieSlicerData(() => ({
      veggieSlicerGraphData: graphObj,
      veggieSlicerTableData: response?.data?.tables,
      veggieSlicerGraphValuesForReport:
        assesmmentForTable === undefined
          ? response?.data?.dashboardPatientTestResponse[0]
          : assesmmentForTable,
    }));
    setIsVeggieSlicerGraphSet(true);

    console.log("trendlinePlotData: ", graphObj);
    console.log("assesmmentForTable: ", assesmmentForTable);
  }

  async function SetGraphTableDataForTug(
    response: any,
    vbTestId: number,
    metricFilter: number,
  ) {
    let graphObj: any = {
      lineGraphValues: [],
      RangeIds: [],
      PatientIds: [],
      VBTestIds: [],
    };

    console.log("metric filter: ", metricFilter);

    response?.data?.dashboardPatientTestResponse.sort((a: any, b: any) => {
      // Convert TestDate values to Date objects for proper comparison
      const dateA: Date = new Date(a.TestDate);
      const dateB: Date = new Date(b.TestDate);

      // Compare the dates
      return dateA.getTime() - dateB.getTime();
    });

    try {
      (response?.data?.dashboardPatientTestResponse ?? []).map((data: any) => {
        const roundedValue = data?.calculatedValue / 1000;
        graphObj.lineGraphValues.push(roundedValue);
        graphObj.RangeIds.push(formatDate(data?.testDate));
        graphObj.PatientIds.push(data?.patientId);
        graphObj.VBTestIds.push(data?.vbTestId);
      });
    } catch (ex: any) {
      console.log(ex);
    }

    let assesmmentForTable = response?.data?.dashboardPatientTestResponse?.find(
      (data: any) => data.vbTestId === vbTestId,
    );

    const patchedAssessment =
      assesmmentForTable === undefined
        ? {
            ...response?.data?.dashboardPatientTestResponse?.slice(-1)[0],
            vbTestLookupId: TestType.tug,
          }
        : { ...assesmmentForTable, vbTestLookupId: TestType.tug };

    console.log(
      "dashboardPatientTestResponse: ",
      response?.data?.dashboardPatientTestResponse?.slice(-1)[0],
    );

    setTugGraphValuesForReport(patchedAssessment);

    setTrendlinePlotTugData(() => ({
      tugGraphData: graphObj,
      tugTableData: response?.data?.tables,
      tugGraphValuesForReport: patchedAssessment,
    }));
    setIsTugGraphSet(true);

    setIsIncompleteTugAssessment(
      response?.data?.dashboardPatientTestResponse?.slice(-1)[0]
        .isIncompleteAssessment || false,
    );

    console.log("trendlinePlotData: ", graphObj);
    console.log("assesmmentForTable: ", assesmmentForTable);
  }

  async function SetGraphTableDataForFunctionalReach(
    response: any,
    vbTestId: number,
    metricFilter: number,
  ) {
    let graphObj: any = {
      lineGraphValues: [],
      RangeIds: [],
      PatientIds: [],
      VBTestIds: [],
    };

    console.log("metric filter: ", metricFilter);
    console.log(
      "functionalReachTestDataStructure:",
      response?.data?.functionalReachTestDataStructure,
    );

    // Process functional reach test data structure
    const functionalReachData: any[] = [];

    if (response?.data?.functionalReachTestDataStructure) {
      const structure = response.data.functionalReachTestDataStructure;

      // Group data by vbTestId (using test.id as the vbTestId)
      const testGroups = new Map();

      structure.visitDataVirtuBalanceTests?.forEach((test: any) => {
        if (!testGroups.has(test.id)) {
          testGroups.set(test.id, {
            test: test,
            phaseValues: [],
            phases: [],
            configs: [],
          });
        }
      });

      // Add phase values to each test group
      structure.visitDataVirtuBalanceTestPhaseValuesBreakup?.forEach(
        (pv: any) => {
          if (testGroups.has(pv.vbTestId)) {
            testGroups.get(pv.vbTestId).phaseValues.push(pv);
          }
        },
      );

      // Add phases to each test group
      structure.visitDataVirtuBalanceTestPhases?.forEach((phase: any) => {
        if (testGroups.has(phase.vbTestId)) {
          testGroups.get(phase.vbTestId).phases.push(phase);
        }
      });

      // Process each test
      testGroups.forEach((group, testId) => {
        const { test, phaseValues, phases } = group;
        const configs = structure.virtubalancetestsconfigs || [];

        console.log("Processing test:", test.id);
        console.log("Phases for this test:", phases);
        console.log(
          "Configs:",
          configs.filter((c: any) => c.vbTestLookupId === TestType.reach),
        );

        console.log("Processing test:", test.vbTestId);
        console.log("Phases for this test:", phases);
        console.log(
          "Configs:",
          configs.filter((c: any) => c.vbTestLookupId === TestType.reach),
        );

        // Sort phase values by phaseId
        const sortedPhaseValues = phaseValues.sort(
          (a: any, b: any) => a.phaseId - b.phaseId,
        );

        let extractedData: any;

        console.log(
          "Calculating functional reach for test:",
          test.applicationLookupId,
        );

        // Check if applicationLookupId is 1 or 2 (desktop)
        if (test.applicationLookupId === 1 || test.applicationLookupId === 2) {
          // Desktop logic - use configs
          // First check if phases have phaseConfig values
          const hasPhaseConfig = phases.some((p: any) => p.phaseConfig != null);

          if (hasPhaseConfig) {
            // Use config-based matching when phaseConfig is available
            const processedPhases =
              configs
                ?.filter(
                  (config: any) => config.vbTestLookupId === TestType.reach,
                )
                .map((config: any) => {
                  console.log(
                    `Processing config with index ${config.index}:`,
                    config,
                  );

                  const matchingPhases =
                    phases?.filter(
                      (p: any) =>
                        p.phaseConfig != null && p.phaseConfig === config.index,
                    ) || [];

                  console.log(
                    `Matching phases for config index ${config.index}:`,
                    matchingPhases,
                  );

                  const phaseScoreSum =
                    matchingPhases.length > 0
                      ? matchingPhases.reduce(
                          (sum: number, p: any) => sum + (p.phaseScore || 0),
                          0,
                        )
                      : 0;

                  console.log(
                    `Phase score sum for ${config.configCode}:`,
                    phaseScoreSum,
                  );

                  // Convert from meters to inches
                  const convertedScore = phaseScoreSum * 39.3701; // meters to inches conversion

                  let phaseScoreValue =
                    Math.round(Number(convertedScore) * 10) / 10;
                  if (matchingPhases.length > 0) {
                    phaseScoreValue =
                      Math.round(
                        (phaseScoreValue / matchingPhases.length) * 10,
                      ) / 10;
                  }

                  const finalScore = isNaN(phaseScoreValue)
                    ? 0
                    : phaseScoreValue;

                  console.log(
                    `Final score for ${config.configCode}:`,
                    finalScore,
                  );

                  let displayKey =
                    config.displayText || config.configCode || "";
                  if (displayKey.toLowerCase() === "forward") {
                    displayKey = "Forward Reach";
                  }

                  return {
                    maximum_reach: finalScore,
                    key: displayKey,
                    code: config.configCode || "",
                  };
                }) || [];

            console.log("Processed phases:", processedPhases);

            const forwardReach =
              processedPhases.find((p: any) => p.code === "forward")
                ?.maximum_reach || 0;
            const leftReach =
              processedPhases.find((p: any) => p.code === "left")
                ?.maximum_reach || 0;
            const rightReach =
              processedPhases.find((p: any) => p.code === "right")
                ?.maximum_reach || 0;

            extractedData = {
              vbTestId: test.id,
              patientId: test.serverId,
              visitId: test.visitID,
              masterTestId: test.masterTestId,
              masterVisitId: test.masterVisitId,
              vbTestLookupId: test.vbTestLookupId,
              workstationId: test.workstationId || 0,
              locationId: test.locationID,
              visitDate: test.time,
              testDate: test.time,
              calculatedValue: forwardReach,
              ForwardReach: forwardReach,
              LeftReach: leftReach,
              RightReach: rightReach,
              phases: processedPhases,
              applicationLookupId: test.applicationLookupId,
            };
          } else {
            // Fallback: use phase values breakup when phaseConfig is null
            // Match phases from visitDataVirtuBalanceTestPhases with phase values
            const processedPhases =
              configs
                ?.filter(
                  (config: any) => config.vbTestLookupId === TestType.reach,
                )
                .map((config: any) => {
                  // Find matching phase by looking at phaseValues for this config's code
                  const matchingPhaseValue = phaseValues.find(
                    (pv: any) =>
                      pv.key === "mode" &&
                      pv.property === "code" &&
                      pv.value === config.configCode,
                  );

                  if (matchingPhaseValue) {
                    // Find the phase with this phaseId
                    const phase = phases.find(
                      (p: any) => p.id === matchingPhaseValue.phaseId,
                    );

                    if (phase) {
                      // Convert from meters to inches
                      const convertedScore = phase.phaseScore * 39.3701;
                      const finalScore =
                        Math.round(Number(convertedScore) * 10) / 10;
                      let displayKey =
                        config.displayText || config.configCode || "";
                      if (displayKey.toLowerCase() === "forward") {
                        displayKey = "Forward Reach";
                      }

                      return {
                        maximum_reach: isNaN(finalScore) ? 0 : finalScore,
                        key: displayKey,
                        code: config.configCode || "",
                      };
                    }
                  }

                  // Return zero if no match found
                  let displayKey =
                    config.displayText || config.configCode || "";
                  if (displayKey.toLowerCase() === "forward") {
                    displayKey = "Forward Reach";
                  }

                  return {
                    maximum_reach: 0,
                    key: displayKey,
                    code: config.configCode || "",
                  };
                }) || [];

            const forwardReach =
              processedPhases.find((p: any) => p.code === "forward")
                ?.maximum_reach || 0;
            const leftReach =
              processedPhases.find((p: any) => p.code === "left")
                ?.maximum_reach || 0;
            const rightReach =
              processedPhases.find((p: any) => p.code === "right")
                ?.maximum_reach || 0;

            extractedData = {
              vbTestId: test.id,
              patientId: test.serverId,
              visitId: test.visitID,
              masterTestId: test.masterTestId,
              masterVisitId: test.masterVisitId,
              vbTestLookupId: test.vbTestLookupId,
              workstationId: test.workstationId || 0,
              locationId: test.locationID,
              visitDate: test.time,
              testDate: test.time,
              calculatedValue: forwardReach,
              ForwardReach: forwardReach,
              LeftReach: leftReach,
              RightReach: rightReach,
              phases: processedPhases,
              applicationLookupId: test.applicationLookupId,
            };

            console.log("Extracted Data FR (desktop):", extractedData);
          }
        } else {
          // Mobile logic - Original logic for applicationLookupId 5
          // Sort by ID to ensure sequential processing
          const sortedData = [
            ...structure.visitDataVirtuBalanceTestPhaseValuesBreakup,
          ].sort((a: any, b: any) => a.id - b.id);

          // Find all index markers to identify phase boundaries
          const indexMarkers = sortedData
            .filter(
              (item: any) => item.key === "mode" && item.property === "index",
            )
            .sort((a: any, b: any) => a.id - b.id);

          console.log("Index markers found:", indexMarkers);
          console.log("All sorted data:", sortedData);

          // Group data by phase - each phase has consecutive items
          const phaseGroups: any = {};

          indexMarkers.forEach((marker: any) => {
            const phaseIndex = marker.value;
            const markerIdx = sortedData.findIndex(
              (item: any) => item.id === marker.id,
            );

            // Each phase group consists of items around the index marker
            // Typically: maximum_reach, maximum_reach_time, code, index
            const phaseItems = sortedData.slice(
              Math.max(0, markerIdx - 2),
              markerIdx + 2,
            );

            console.log(
              `Phase ${phaseIndex} (marker at ${marker.id}):`,
              phaseItems,
            );
            phaseGroups[phaseIndex] = phaseItems;
          });

          console.log("Phase groups:", phaseGroups);

          // Extract phases data
          const extractedPhases = Object.values(phaseGroups).map(
            (phaseData: any) => {
              const maxReach = phaseData.find(
                (item: any) => item.property === "maximum_reach",
              );
              const maxReachTime = phaseData.find(
                (item: any) => item.property === "maximum_reach_time",
              );

              // Look for mode.code and mode.index
              const modeCode = phaseData.find(
                (item: any) =>
                  (item.key === "mode" || item.key === "phases") &&
                  item.property === "code",
              );
              const modeIndex = phaseData.find(
                (item: any) =>
                  (item.key === "mode" || item.key === "phases") &&
                  item.property === "index",
              );

              // Convert from meters to inches
              const maxReachValue = Number(maxReach?.value || 0);
              const convertedReach = maxReachValue * 39.3701;
              // const convertedReach = maxReachValue;

              const finalReach = Math.round(convertedReach * 10) / 10;

              return {
                maximum_reach: finalReach,
                maximum_reach_time: Number(maxReachTime?.value || 0),
                phase_score: finalReach,
                mode: {
                  index: Number(modeIndex?.value || 0),
                  code: modeCode?.value || "",
                },
              };
            },
          );

          console.log("Extracted phases FR:", extractedPhases);

          const forwardReach =
            extractedPhases.find((p: any) => p.mode.code === "forward")
              ?.maximum_reach || 0;
          const leftReach =
            extractedPhases.find((p: any) => p.mode.code === "left")
              ?.maximum_reach || 0;
          const rightReach =
            extractedPhases.find((p: any) => p.mode.code === "right")
              ?.maximum_reach || 0;

          extractedData = {
            vbTestId: test.id,
            patientId: test.serverId,
            visitId: test.visitID,
            masterTestId: test.masterTestId,
            masterVisitId: test.masterVisitId,
            vbTestLookupId: test.vbTestLookupId,
            workstationId: test.workstationId || 0,
            locationId: test.locationID,
            visitDate: test.time,
            testDate: test.time,
            calculatedValue: forwardReach,
            ForwardReach: forwardReach,
            LeftReach: leftReach,
            RightReach: rightReach,
            phases: extractedPhases,
            applicationLookupId: test.applicationLookupId,
          };

          console.log("Extracted Data FR (mobile):", extractedData);
        }

        functionalReachData.push(extractedData);
      });

      // Sort by test date
      functionalReachData.sort(
        (a, b) =>
          new Date(a.testDate).getTime() - new Date(b.testDate).getTime(),
      );
    }

    console.log("Processed Functional Reach Data:", functionalReachData);

    // Build graph data based on metric filter
    if (metricFilter === 1) {
      // Forward Reach
      try {
        functionalReachData.forEach((data: any) => {
          graphObj.lineGraphValues.push(data.ForwardReach);
          graphObj.RangeIds.push(
            formatDate(convertISOToReadableDate(data.testDate)),
          );
          graphObj.PatientIds.push(data.patientId);
          graphObj.VBTestIds.push(data.vbTestId);
        });
      } catch (ex: any) {
        console.log(ex);
      }
    } else if (metricFilter === 2) {
      // Lateral Reach (Left and Right)
      const leftValues: number[] = [];
      const rightValues: number[] = [];
      const testDates: string[] = [];
      const patientIds: number[] = [];
      const vbTestIds: number[] = [];

      try {
        functionalReachData.forEach((data: any) => {
          leftValues.push(data.LeftReach);
          rightValues.push(data.RightReach);
          testDates.push(formatDate(convertISOToReadableDate(data.testDate)));
          patientIds.push(data.patientId);
          vbTestIds.push(data.vbTestId);
        });

        graphObj.lineGraphValues = [leftValues, rightValues];
        graphObj.RangeIds = testDates;
        graphObj.PatientIds = patientIds;
        graphObj.VBTestIds = vbTestIds;
      } catch (ex: any) {
        console.log(ex);
      }
    }

    // Find assessment for table
    let assesmmentForTable = functionalReachData.find(
      (data: any) => data.vbTestId === vbTestId,
    );

    console.log(
      "Functional Reach Data (last):",
      functionalReachData[functionalReachData.length - 1],
    );

    setFunctionalReachGraphValuesForReport(
      assesmmentForTable === undefined
        ? functionalReachData[functionalReachData.length - 1]
        : assesmmentForTable,
    );

    // Build tables for functional reach - only for the selected test
    const selectedData =
      assesmmentForTable === undefined
        ? functionalReachData[functionalReachData.length - 1]
        : assesmmentForTable;

    const functionalReachTables: any[] = [];

    console.log("Selected Data for Tables:", selectedData);

    if (selectedData) {
      // Calculate mobility based on forward reach value
      let mobilityStatus = "";
      const forwardReachValue = selectedData.ForwardReach || 0;

      if (forwardReachValue > 10) {
        mobilityStatus = "High";
      } else if (forwardReachValue <= 10 && forwardReachValue >= 6) {
        mobilityStatus = "Medium";
      } else if (forwardReachValue < 6) {
        mobilityStatus = "Low";
      }

      // Table 1: Forward Reach and Mobility
      const forwardTable = {
        name: "",
        columns: [{ ColumnNames: "Measure" }, { ColumnNames: "Score" }],
        rows: [
          {
            Measure: "Mobility",
            Score: mobilityStatus || "N/A",
          },
          {
            Measure: "Forward Reach (in)",
            Score: selectedData.ForwardReach || 0,
          },
        ],
      };

      // Table 2: Lateral Reach (Left & Right)
      const lateralTable = {
        name: "",
        columns: [
          { ColumnNames: "Measure" },
          { ColumnNames: "Left" },
          { ColumnNames: "Right" },
        ],
        rows: [
          {
            Measure: "Lateral Reach (in)",
            Left: selectedData.LeftReach || 0,
            Right: selectedData.RightReach || 0,
          },
        ],
      };

      functionalReachTables.push(forwardTable, lateralTable);
    }

    console.log("Table data:", functionalReachTables);

    setTrendlinePlotFunctionalReachData(() => ({
      functionalReachGraphData: graphObj,
      functionalReachTableData: functionalReachTables,
      functionalReachGraphValuesForReport:
        assesmmentForTable === undefined
          ? functionalReachData[0]
          : assesmmentForTable,
    }));
    setIsFunctionalReachGraphSet(true);

    console.log("trendlinePlotData: ", graphObj);
    console.log("assesmmentForTable: ", assesmmentForTable);
  }

  async function SetGraphTableDataForMctsib(
    response: any,
    vbTestId: number,
    metricFilter: number,
  ) {
    let graphObj: any = {
      lineGraphValues: [],
      RangeIds: [],
      PatientIds: [],
      VBTestIds: [],
    };

    response?.data?.mctsibTrendlineGraphData.sort((a: any, b: any) => {
      // Convert TestDate values to Date objects for proper comparison
      const dateA: Date = new Date(a.TestDate);
      const dateB: Date = new Date(b.TestDate);

      // Compare the dates
      return dateA.getTime() - dateB.getTime();
    });

    try {
      (response?.data?.mctsibTrendlineGraphData ?? []).map((data: any) => {
        graphObj.lineGraphValues.push(data.value);
        graphObj.RangeIds.push(formatDate(data.testDate));
        graphObj.PatientIds.push(data.patientId);
        graphObj.VBTestIds.push(data.vbTestId);
      });
    } catch (ex: any) {
      console.log(ex);
    }

    let assesmmentForTable = response?.data?.mctsibTrendlineGraphData.find(
      (data: any) => data.vbTestId == vbTestId,
    );

    console.log(
      "mctsibTrendlineGraphData: ",
      response?.data?.mctsibTrendlineGraphData?.slice(-1)[0],
    );

    setMctsibGraphValuesForReport(
      assesmmentForTable === undefined
        ? response?.data?.mctsibTrendlineGraphData?.slice(-1)[0]
        : assesmmentForTable,
    );

    setTrendlinePlotMctsibData(() => ({
      mctsibGraphData: graphObj,
      mctsibTableData: response?.data?.tables,
      mctsibGraphValuesForReport:
        assesmmentForTable === undefined
          ? response?.data?.mctsibTrendlineGraphData[0]
          : assesmmentForTable,
    }));
    setIsMctsibGraphSet(true);

    console.log("trendlinePlotData: ", graphObj);
    console.log("assesmmentForTable: ", assesmmentForTable);
  }
  const formatNumber = (value: number): string => {
    return Number.isInteger(value) ? value.toString() : value.toFixed(2);
  };

  async function SetGraphTableDataForAppleFrenzy(
    response: any,
    vbTestId: number,
    metricFilter: number,
  ) {
    let graphObj: any = {
      lineGraphValues: [],
      RangeIds: [],
      PatientIds: [],
      VBTestIds: [],
    };

    console.log(
      "before sorting: ",
      response?.data?.appleFrenzyTrendlineGraphData,
    );
    // First sort by date and then by property
    response?.data?.appleFrenzyTrendlineGraphData?.sort((a: any, b: any) => {
      // First sort by date
      const dateCompare =
        new Date(a.testDate).getTime() - new Date(b.testDate).getTime();

      if (dateCompare === 0) {
        // If dates are same, sort by property (goodApplePercentageCaught first)
        if (a.property === "goodApplePercentageCaught") return -1;
        if (b.property === "badApplePercentageCaught") return 1;
        return 0;
      }

      return dateCompare;
    });
    console.log(
      "after sorting: ",
      response?.data?.appleFrenzyTrendlineGraphData,
    );

    //Calculating percentage for apple frenzy graph
    response?.data?.appleFrenzyTrendlineGraphData.map((data: any) => {
      const score = parseFloat(data.calculatedValue); // Convert string to number
      if (!isNaN(score)) {
        data.calculatedValue = formatNumber(score * 100);
      } else {
        data.calculatedValue = "0";
      }
    });

    try {
      response?.data?.appleFrenzyTrendlineGraphData?.map((data: any) => {
        graphObj.lineGraphValues.push(data.calculatedValue);
        graphObj.RangeIds.push(formatDate(data.testDate));
        graphObj.PatientIds.push(data.patientId);
        graphObj.VBTestIds.push(data.vbTestId);
      });
    } catch (ex: any) {
      console.log(ex);
    }

    let assesmmentForTable = response?.data?.appleFrenzyTrendlineGraphData.find(
      (data: any) => data.vbTestId === vbTestId,
    );

    console.log(
      "dashboardPatientTestResponse: ",
      response?.data?.appleFrenzyTrendlineGraphData?.slice(-1)[0],
    );

    setAppleFrenzyGraphValuesForReport(
      assesmmentForTable === undefined
        ? response?.data?.appleFrenzyTrendlineGraphData?.slice(-1)[0]
        : assesmmentForTable,
    );

    setTrendlinePlotAppleFrenzyData(() => ({
      appleFrenzyGraphData: graphObj,
      appleFrenzyTableData: response?.data?.tables,
      appleFrenzyGraphValuesForReport:
        assesmmentForTable === undefined
          ? response?.data?.appleFrenzyTrendlineGraphData[0]
          : assesmmentForTable,
    }));
    setIsAppleFrenzyGraphSet(true);

    console.log("trendlinePlotData: ", graphObj);
    console.log("assesmmentForTable: ", assesmmentForTable);
  }

  async function GetTrendlineGraphDetails(
    assessmentType: TestType,
    patientServerId: number,
    vbTestId: number,
    metricFilter: number = 1,
  ) {
    console.log("Patient info in func", patientInfo);
    try {
      await GetTrendlineGraph({
        ServerId: patientServerId,
        EncryptedServerId: localStorage.getItem("EncryptedServerId"),
        VBTestId: vbTestId,
        VBTestLookupId: assessmentType,
        Trendline: metricFilter,
      })
        .then(async function (response) {
          setCurrentMetric(metricFilter);
          if (assessmentType === TestType.gait) {
            SetGraphTableDataForGait(response, vbTestId, metricFilter);
          }

          if (assessmentType === TestType.five_x_sit_stand) {
            SetGraphTableDataFor5XSTS(response, vbTestId, metricFilter);
          }

          if (assessmentType === TestType.upper_body_arom) {
            SetGraphTableDataForUpperBodyAROM(response, vbTestId, metricFilter);
          }

          if (assessmentType === TestType.red_light_green_light) {
            SetGraphTableDataForRLGL(response, vbTestId, metricFilter);
          }

          if (assessmentType === TestType.hec_training) {
            SetGraphTableDataForBalloonPopper(response, vbTestId, metricFilter);
          }

          if (assessmentType === TestType.game_AF) {
            SetGraphTableDataForAppleFrenzy(response, vbTestId, metricFilter);
          }

          if (assessmentType === TestType.veggie_samurai) {
            SetGraphTableDataForVeggieSlicer(response, vbTestId, metricFilter);
          }

          if (assessmentType === TestType.tug) {
            SetGraphTableDataForTug(response, vbTestId, metricFilter);
          }

          if (assessmentType === TestType.reach) {
            SetGraphTableDataForFunctionalReach(
              response,
              vbTestId,
              metricFilter,
            );
          }
          if (assessmentType === TestType.ctsib) {
            SetGraphTableDataForMctsib(response, vbTestId, metricFilter);
          }
        })
        .catch((error) => {
          history.push("/confirmation", {
            actionType: ActionType.FailureAPIResponse,
          });
        });
    } catch (error) {
      history.push("/confirmation", {
        actionType: ActionType.FailureAPIResponse,
      });
      console.error(error);
    }
  }

  let location =
    window.location.href === window.location.origin + "/patient-page";

  const awaitableFuncs = async () => {
    await GetPatientVisitDetails();
  };

  useOnClickOutside(elementRef, () => setIsDropdownOpen(false));

  function useOnClickOutside(elementRef: any, handler: any) {
    useEffect(() => {
      const listener = (event: any) => {
        if (!elementRef.current || elementRef.current.contains(event.target)) {
          return;
        }
        handler(event);
      };
      document.addEventListener("mousedown", listener);
      document.addEventListener("touchstart", listener);
      document.addEventListener("click", listener);
      return () => {
        document.removeEventListener("mousedown", listener);
        document.removeEventListener("touchstart", listener);
        document.addEventListener("click", listener);
      };
    }, [elementRef, handler]);
  }

  useEffect(() => {
    setIsDuplicateCalled(false);
    const rtmEnabled = localStorage.getItem("isRtmEnabled") === "true";
    setIsRtmConfigurationEnabled(rtmEnabled);
    rtmEnabledRef.current = rtmEnabled;
    if (location) {
      setLoading(false);
      setPatientInformation(undefined);
      setPatientSummariesList([]);
      awaitableFuncs();
    }
  }, [location]);

  function isEmpty(obj: Record<string, any>): boolean {
    return Object.keys(obj).length === 0;
  }

  const colorModes = {
    green: "#43BA73",
    orange: "#F8993A",
    red: "#DB4B4B",
    blue: "#6F86F8",
    yellow: "#F8993A",
  };

  const getValueColor = (value: string) => {
    console.log("currentFallRisk: ", currentFallRisk);
    if (value === "green") {
      return colorModes.green;
    } else if (value === "orange") {
      return colorModes.orange;
    } else if (value === "red") {
      return colorModes.red;
    } else if (value === "blue") {
      return colorModes.blue;
    } else if (value === "yellow") {
      return colorModes.yellow;
    }
  };

  const getRiskLevel = (value: any) => {
    if (value < 0.7) {
      return "LOW";
    } else if (value >= 0.7 && value < 1.07) {
      return "MED";
    } else if (value >= 1.07) {
      return "HIGH";
    }
  };

  const callGaitApiAgain = (value: any) => {
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    if (value !== undefined) {
      let ServerId, VbTestId;
      if (
        trendlinePlotGaitData?.gaitGraphData.PatientIds &&
        trendlinePlotGaitData?.gaitGraphData.VBTestIds
      ) {
        ServerId = trendlinePlotGaitData?.gaitGraphData.PatientIds[value];
        VbTestId = trendlinePlotGaitData?.gaitGraphData.VBTestIds[value];
      }

      GetTrendlineGraphDetails(
        TestType.gait,
        ServerId,
        VbTestId,
        currentMetric,
      );
    }
  };

  const call5xApiAgain = (value: any) => {
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    if (value !== undefined) {
      let ServerId, VbTestId;
      if (
        trendlinePlot5xData?.sitStandGraphData.PatientIds &&
        trendlinePlot5xData?.sitStandGraphData.VBTestIds
      ) {
        ServerId = trendlinePlot5xData?.sitStandGraphData.PatientIds[value];
        VbTestId = trendlinePlot5xData?.sitStandGraphData.VBTestIds[value];
      }

      GetTrendlineGraphDetails(TestType.five_x_sit_stand, ServerId, VbTestId);
    }
  };

  const callRLGLApiAgain = (value: any) => {
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    if (value !== undefined) {
      let ServerId, VbTestId;
      if (
        trendlinePlotRLGLData?.rlglGraphData.PatientIds &&
        trendlinePlotRLGLData?.rlglGraphData.VBTestIds
      ) {
        ServerId = trendlinePlotRLGLData?.rlglGraphData.PatientIds[value];
        VbTestId = trendlinePlotRLGLData?.rlglGraphData.VBTestIds[value];
      }

      GetTrendlineGraphDetails(
        TestType.red_light_green_light,
        ServerId,
        VbTestId,
        currentMetric,
      );
    }
  };

  const callAROMApiAgain = (value: any) => {
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    if (value !== undefined) {
      let ServerId, VbTestId;
      if (
        trendlinePlotAROMData?.aromGraphData.PatientIds &&
        trendlinePlotAROMData?.aromGraphData.VBTestIds
      ) {
        //Filtering the VBTestIds to avoid multiple calls for same VBTestIds
        const filteredVbTestIds: any[] = [];
        for (
          let i = 0;
          i < trendlinePlotAROMData?.aromGraphData.VBTestIds.length;
          i++
        ) {
          if (
            !filteredVbTestIds.includes(
              trendlinePlotAROMData?.aromGraphData.VBTestIds[i],
            )
          ) {
            filteredVbTestIds.push(
              trendlinePlotAROMData?.aromGraphData.VBTestIds[i],
            );
          }
        }
        ServerId = trendlinePlotAROMData?.aromGraphData.PatientIds[value];
        VbTestId = filteredVbTestIds[value];
      }

      GetTrendlineGraphDetails(
        TestType.upper_body_arom,
        ServerId,
        VbTestId,
        currentMetric,
      );
    }
  };

  const callBalloonPopperApiAgain = (value: any) => {
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }

    if (value !== undefined) {
      let ServerId, VbTestId;
      if (
        trendlinePlotBalloonPopperData?.balloonPopperGraphData.PatientIds &&
        trendlinePlotBalloonPopperData?.balloonPopperGraphData.VBTestIds
      ) {
        //Filtering the VBTestIds to avoid multiple calls for same VBTestIds
        const filteredVbTestIds: any[] = [];

        if (currentMetric === 3) {
          for (
            let i = 0;
            i <
            trendlinePlotBalloonPopperData?.balloonPopperGraphData.VBTestIds
              .length;
            i++
          ) {
            if (
              !filteredVbTestIds.includes(
                trendlinePlotBalloonPopperData?.balloonPopperGraphData
                  .VBTestIds[i],
              )
            ) {
              filteredVbTestIds.push(
                trendlinePlotBalloonPopperData?.balloonPopperGraphData
                  .VBTestIds[i],
              );
            }
          }
        }

        console.log("filteredVbTestIds", filteredVbTestIds);

        ServerId =
          trendlinePlotBalloonPopperData?.balloonPopperGraphData.PatientIds[
            value
          ];
        VbTestId =
          currentMetric === 3
            ? filteredVbTestIds[value]
            : trendlinePlotBalloonPopperData?.balloonPopperGraphData.VBTestIds[
                value
              ];
      }

      GetTrendlineGraphDetails(
        TestType.hec_training,
        ServerId,
        VbTestId,
        currentMetric,
      );
    }
  };

  const callVeggieSlicerApiAgain = (value: any) => {
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    if (value !== undefined) {
      let ServerId, VbTestId;
      if (
        trendlinePlotVeggieSlicerData?.veggieSlicerGraphData.PatientIds &&
        trendlinePlotVeggieSlicerData?.veggieSlicerGraphData.VBTestIds
      ) {
        ServerId =
          trendlinePlotVeggieSlicerData?.veggieSlicerGraphData.PatientIds[
            value
          ];
        VbTestId =
          trendlinePlotVeggieSlicerData?.veggieSlicerGraphData.VBTestIds[value];
      }

      GetTrendlineGraphDetails(
        TestType.veggie_samurai,
        ServerId,
        VbTestId,
        currentMetric,
      );
    }
  };

  const callTugApiAgain = (value: any) => {
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    if (value !== undefined) {
      let ServerId, VbTestId;
      if (
        trendlinePlotTugData?.tugGraphData.PatientIds &&
        trendlinePlotTugData?.tugGraphData.VBTestIds
      ) {
        ServerId = trendlinePlotTugData?.tugGraphData.PatientIds[value];
        VbTestId = trendlinePlotTugData?.tugGraphData.VBTestIds[value];
      }

      GetTrendlineGraphDetails(TestType.tug, ServerId, VbTestId, currentMetric);
    }
  };

  const callFunctionalReachApiAgain = (value: any) => {
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    if (value !== undefined) {
      let ServerId, VbTestId;
      if (
        trendlinePlotFunctionalReachData?.functionalReachGraphData.PatientIds &&
        trendlinePlotFunctionalReachData?.functionalReachGraphData.VBTestIds
      ) {
        ServerId =
          trendlinePlotFunctionalReachData?.functionalReachGraphData.PatientIds[
            value
          ];
        VbTestId =
          trendlinePlotFunctionalReachData?.functionalReachGraphData.VBTestIds[
            value
          ];
      }

      GetTrendlineGraphDetails(
        TestType.reach,
        ServerId,
        VbTestId,
        currentMetric,
      );
    }
  };

  const callAppleFrenzyApiAgain = (value: any) => {
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    if (value !== undefined) {
      let ServerId, VbTestId;

      if (
        trendlinePlotAppleFrenzyData?.appleFrenzyGraphData.PatientIds &&
        trendlinePlotAppleFrenzyData?.appleFrenzyGraphData.VBTestIds
      ) {
        //Filtering the VBTestIds to avoid multiple calls for same VBTestIds
        const filteredVbTestIds: any[] = [];
        for (
          let i = 0;
          i <
          trendlinePlotAppleFrenzyData?.appleFrenzyGraphData.VBTestIds.length;
          i++
        ) {
          if (
            !filteredVbTestIds.includes(
              trendlinePlotAppleFrenzyData?.appleFrenzyGraphData.VBTestIds[i],
            )
          ) {
            filteredVbTestIds.push(
              trendlinePlotAppleFrenzyData?.appleFrenzyGraphData.VBTestIds[i],
            );
          }
        }

        console.log("filteredVbTestIds", filteredVbTestIds);

        ServerId =
          trendlinePlotAppleFrenzyData?.appleFrenzyGraphData.PatientIds[value];
        VbTestId = filteredVbTestIds[value];
      }

      GetTrendlineGraphDetails(
        TestType.game_AF,
        ServerId,
        VbTestId,
        currentMetric,
      );
    }
  };
  const callMctsibApiAgain = (value: any) => {
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    if (value !== undefined) {
      let ServerId, VbTestId;

      if (
        trendlinePlotMctsibData?.mctsibGraphData.PatientIds &&
        trendlinePlotMctsibData?.mctsibGraphData.VBTestIds
      ) {
        //Filtering the VBTestIds to avoid multiple calls for same VBTestIds
        const filteredVbTestIds: any[] = [];
        for (
          let i = 0;
          i < trendlinePlotMctsibData?.mctsibGraphData.VBTestIds.length;
          i++
        ) {
          if (
            !filteredVbTestIds.includes(
              trendlinePlotMctsibData?.mctsibGraphData.VBTestIds[i],
            )
          ) {
            filteredVbTestIds.push(
              trendlinePlotMctsibData?.mctsibGraphData.VBTestIds[i],
            );
          }
        }

        console.log("filteredVbTestIds", filteredVbTestIds);

        ServerId = trendlinePlotMctsibData?.mctsibGraphData.PatientIds[value];
        VbTestId = filteredVbTestIds[value];
      }

      GetTrendlineGraphDetails(
        TestType.ctsib,
        ServerId,
        VbTestId,
        currentMetric,
      );
    }
  };

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState<AssessmentMetric | null>(
    null,
  );
  const [assessmentMetrics, setAssessmentMetrics] = useState<
    AssessmentMetric[] | null
  >(null);
  const [searchText, setSearchText] = useState("");

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const selectDropdownItem = (item: AssessmentMetric) => {
    setYMappings(null);
    setSelectedItem(item);
    setIsDropdownOpen(false);
    graphChanged(item);
  };

  const graphChanged = (assessmentType: AssessmentMetric) => {
    console.log("graphChanged called with:", {
      id: assessmentType.id,
      name: assessmentType.name,
      lookupTypeId: assessmentType.lookupTypeId,
    });

    setTrendlinePlotGaitData(() => ({
      gaitGraphData: [],
      gaitTableData: [],
      gaitGraphValuesForReport: [],
    }));
    setIsGaitGraphSet(false);
    setTrendlinePlot5xData(() => ({
      sitStandGraphData: [],
      sitStandTableData: [],
      sitStandGraphValuesForReport: [],
    }));
    setIs5xGraphSet(false);
    setTrendlinePlotAROMData(() => ({
      aromGraphData: [],
      aromTableData: [],
      aromGraphValuesForReport: [],
    }));
    setIsAROMGraphSet(false);
    setTrendlinePlotRLGLData(() => ({
      rlglGraphData: [],
      rlglTableData: [],
      rlglGraphValuesForReport: [],
    }));
    setIsRLGLGraphSet(false);
    setTrendlinePlotBalloonPopperData(() => ({
      balloonPopperGraphData: [],
      balloonPopperTableData: [],
      balloonPopperGraphValuesForReport: [],
    }));
    setIsBalloonPopperGraphSet(false);
    setTrendlinePlotAppleFrenzyData(() => ({
      appleFrenzyGraphData: [],
      appleFrenzyTableData: [],
      appleFrenzyGraphValuesForReport: [],
    }));
    setIsAppleFrenzyGraphSet(false);
    setTrendlinePlotVeggieSlicerData(() => ({
      veggieSlicerGraphData: [],
      veggieSlicerTableData: [],
      veggieSlicerGraphValuesForReport: [],
    }));
    setIsVeggieSlicerGraphSet(false);
    setTrendlinePlotTugData(() => ({
      tugGraphData: [],
      tugTableData: [],
      tugGraphValuesForReport: [],
    }));
    setIsTugGraphSet(false);
    setTrendlinePlotFunctionalReachData(() => ({
      functionalReachGraphData: [],
      functionalReachTableData: [],
      functionalReachGraphValuesForReport: [],
    }));
    setIsFunctionalReachGraphSet(false);
    setTrendlinePlotMctsibData(() => ({
      mctsibGraphData: [],
      mctsibTableData: [],
      mctsibGraphValuesForReport: [],
    }));
    setIsMctsibGraphSet(false);

    if (assessmentType.lookupTypeId !== TestType.game_AF) {
      setActiveTab("lean");
    }

    if (
      localStorage.getItem("patientGraphId") !== "undefined" &&
      localStorage.getItem("patientGraphId") !== null
    ) {
      const patientServerId = localStorage.getItem("patientGraphId");
      switch (assessmentType.id) {
        case 1:
        case 3:
        case 4:
        case 8:
        case 10:
        case 11:
        case 14:
        case 16:
        case 17:
        case 101:
          //Gait Speed, 5XSTS Time, RLGL Red Lights Missed, Score Per Minute Balloon Popper, Score Per Minute Veggie Slicer, Total Time TUG, Forward Reach, Apple Percentage Caught
          GetTrendlineGraphDetails(
            assessmentType.lookupTypeId,
            Number(patientServerId),
            0,
            1,
          );
          break;
        case 2:
        case 5:
        case 9:
        case 12:
        case 15:
        case 18:
        case 102:
          //Gait Mobility, RLGL Average Speed, Average Time to Hit, Lateral Reach, Total Veggies Cut
          GetTrendlineGraphDetails(
            assessmentType.lookupTypeId,
            Number(patientServerId),
            0,
            2,
          );
          break;
        case 6:
        case 13:
        case 103:
          //Balloons Per Minute
          GetTrendlineGraphDetails(
            assessmentType.lookupTypeId,
            Number(patientServerId),
            0,
            3,
          );
          break;
        case 7:
          GetTrendlineGraphDetails(
            assessmentType.lookupTypeId,
            Number(patientServerId),
            0,
            4,
          );
          break;
        case 19:
          // mCTSIB Visual
          GetTrendlineGraphDetails(
            assessmentType.lookupTypeId,
            Number(patientServerId),
            0,
            1,
          );
          break;
        case 20:
          // mCTSIB Somatosensory
          GetTrendlineGraphDetails(
            assessmentType.lookupTypeId,
            Number(patientServerId),
            0,
            3,
          );
          break;
        case 21:
          // mCTSIB Vestibular
          GetTrendlineGraphDetails(
            assessmentType.lookupTypeId,
            Number(patientServerId),
            0,
            2,
          );
          break;
        case 22:
          // mCTSIB Composite
          GetTrendlineGraphDetails(
            assessmentType.lookupTypeId,
            Number(patientServerId),
            0,
            4,
          );
          break;
        // case 16:
        //   GetTrendlineGraphDetails(
        //     assessmentType.lookupTypeId,
        //     Number(patientServerId),
        //     0,
        //     5
        //   );
        //   break;
        default:
          // Fallback for mCTSIB or other tests - determine metric from assessment name
          if (assessmentType.lookupTypeId === TestType.ctsib) {
            let metricId = 1;
            if (assessmentType.name?.toLowerCase().includes("vestibular")) {
              metricId = 2;
            } else if (
              assessmentType.name?.toLowerCase().includes("somatosensory")
            ) {
              metricId = 3;
            } else if (
              assessmentType.name?.toLowerCase().includes("composite")
            ) {
              metricId = 4;
            }
            GetTrendlineGraphDetails(
              assessmentType.lookupTypeId,
              Number(patientServerId),
              0,
              metricId,
            );
          }
          break;
      }
    }
  };

  const filteredMetrics = (assessmentMetrics || []).filter((metric) =>
    (metric?.name ?? "").toLowerCase().includes(searchText.toLowerCase()),
  );

  function getAssessmentTypeName(lookupId: any) {
    if (lookupId === 21) {
      return "Balloon Popper Training";
    } else if (lookupId === 22) {
      return "Gait Assessment";
    } else if (lookupId === 35) {
      return "5XSTS Assessment";
    } else if (lookupId === 41) {
      return "Veggie Slicer Training";
    } else if (lookupId === 50) {
      return "Apple Frenzy Training";
    } else if (lookupId === 51) {
      return "RLGL Training";
    } else if (lookupId === 55) {
      return "AROM Assessment";
    } else if (lookupId === 31) {
      return "TUG Assessment";
    } else if (lookupId === 2) {
      return "Functional Reach Assessment";
    } else if (lookupId === 1) {
      return "mCTSIB Assessment";
    }
  }

  function changeAppleFrenzyMode(selectedMode: any) {
    let id: number = 10;
    if (selectedMode === 1) {
      id = 101;
    } else if (selectedMode === 2) {
      id = 102;
    } else if (selectedMode === 3) {
      id = 103;
    }
    const appleFrenzy = new AssessmentMetric();
    appleFrenzy.id = id;
    appleFrenzy.lookupTypeId = TestType.game_AF;
    appleFrenzy.name = "Apple Percentage Caught";
    selectDropdownItem(appleFrenzy);
  }

  const enableDisablePatientRtm = async (
    isNewEpisode: boolean,
    isRtmReenable: boolean,
  ) => {
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    try {
      await EnableDisablePatientRtm({
        PatientId: localStorage.getItem("patientServerID"),
        EncryptedServerId: localStorage.getItem("EncryptedServerId"),
        IsPatientRTMEnabled: !patientInformation?.isPatientRTMEnabled,
        LocalDateTime: localDateTime(),
        IsNewEpisode: isNewEpisode,
        IsRtmReenable: isRtmReenable,
        MasterUserId: JSON.parse(localStorage.getItem("patientMasterID")!),
        MobilePhone: localStorage.getItem("patientMobileNumber") ?? "",
      }).then(async function (response: any) {
        console.log("Response: ", response);
        if (response?.data?.dbResponse?.id > 0) {
          let status;
          if (!patientInformation?.isPatientRTMEnabled) {
            status = "true";
          } else {
            status = "false";
          }
          sessionStorage.setItem("isPatientRtmTrue", status);
          sessionStorage.setItem(
            "patientDetails",
            JSON.stringify(patientInformation),
          );
          if (!patientInformation?.isPatientRTMEnabled) {
            setPatientDetails((prevState: PatientVM) => ({
              ...prevState,
              isRtmEverEnabled: true,
            }));
            setPatientDetailsRecoil((prevState: PatientVM) => ({
              ...prevState,
              isRtmEverEnabled: true,
            }));
            setPatientInformation((prevState: any) => ({
              ...prevState,
              isRtmEverEnabled: true,
            }));
          }
          handleEducationCloseFromEnabling();
        }
      });
    } catch (error) {
      history.push("/confirmation", {
        actionType: ActionType.FailureAPIResponse,
      });
      console.error(error);
    }
  };

  //RTM Toggle
  const handleRtmToggle = async () => {
    console.log(
      "patientInformation?.isPatientRTMEnabled",
      patientInformation?.isPatientRTMEnabled,
    );
    if (patientInformation?.isPatientRTMEnabled) {
      setRemoteTherapeuticMonitoring(true);
    } else {
      if (patientInformation?.isRtmEverEnabled) {
        // RTM has been enabled before, open ChooseEpisodeModal
        setIsRtmReenable(true);
        setChooseEpisode(true);
      } else {
        // First time enabling RTM, open ConsentForm
        setIsRtmReenable(false);
        setConsentForm(true);
      }
    }
  };

  const handleConsentFormObject = (data: any) => {
    console.log("Received from ConsentFormModal:", data);
    setIsNewEpisode(true);
    setConsentFormData(data);
    setConsentForm(false);
    // First time RTM enablement, open SetupEpisode modal
    setSetupEpisode(true);
    setPatientDetails((prevState: PatientVM) => ({
      ...prevState,
      email: data.Email,
      mobilePhone: data.MobilePhone,
    }));
    setPatientDetailsRecoil((prevState: PatientVM) => ({
      ...prevState,
      email: data.Email,
      mobilePhone: data.MobilePhone,
    }));
    setPatientInformation((prevState: any) => ({
      ...prevState,
      email: data.Email,
      mobilePhone: data.MobilePhone,
    }));
  };

  const handleConsentClose = async () => {
    setConsentForm(false);
    await enableDisablePatientRtm(true, false);
    const isSFTPPatient =
      localStorage.getItem("isSFTPPatient") === "true" ? true : false;
    if (isSFTPPatient || true) {
      handleEducationClose();
    } else {
      setCompletedEducation(true);
    }
  };

  const handleSetupEpisodeClose = async () => {
    setSetupEpisode(false);
    await enableDisablePatientRtm(true, false);
    handleEducationClose();
  };

  const handleChooseEpisodeClose = async () => {
    setIsNewEpisode(false);
    setChooseEpisode(false);
    await enableDisablePatientRtm(false, true);
    handleEducationClose();
  };

  const handleNewEpisodeClose = async () => {
    setIsNewEpisode(true);
    setNewEpisode(false);
    await enableDisablePatientRtm(true, true);
    handleEducationClose();
  };

  const handleEducationClose = (isEducationProvided?: boolean) => {
    setCompletedEducation(false);
    setRtmEnabled(true);
    if (isEducationProvided) {
      setPatientDetails((prevState: PatientVM) => ({
        ...prevState,
        isEverEducated: true,
      }));
      setPatientDetailsRecoil((prevState: PatientVM) => ({
        ...prevState,
        isEverEducated: true,
      }));
      setPatientInformation((prevState: any) => ({
        ...prevState,
        isEverEducated: true,
      }));
    }
    // setOpenRtmModal(true);
  };

  const handleEducationCloseFromEnabling = () => {
    setCompletedEducation(false);
    setRtmEnabled(true);
    setOpenRtmModal(true);
  };

  const handleDisableConsentClose = () => {
    setRemoteTherapeuticMonitoring(false);
    setRtmEnabled(false);
    setOpenRtmModal(true);
  };

  const handleEnableDisableModalClose = (isEnabled: boolean) => {
    setOpenRtmModal(false);
    if (!isEnabled) {
      setPatientDetails((prevState: PatientVM) => ({
        ...prevState,
        isPatientRTMEnabled: false,
      }));
      setPatientDetailsRecoil((prevState: PatientVM) => ({
        ...prevState,
        isPatientRTMEnabled: false,
      }));
      setPatientInformation((prevState: any) => ({
        ...prevState,
        isPatientRTMEnabled: false,
      }));
    } else {
      setPatientDetails((prevState: PatientVM) => ({
        ...prevState,
        isPatientRTMEnabled: true,
        isRtmEverEnabled: true,
      }));
      setPatientDetailsRecoil((prevState: PatientVM) => ({
        ...prevState,
        isPatientRTMEnabled: true,
        isRtmEverEnabled: true,
      }));
      setPatientInformation((prevState: any) => ({
        ...prevState,
        isPatientRTMEnabled: false,
        isRtmEverEnabled: true,
      }));
      history.push("/full-visit-summary", {
        patientInfo: patientDetails,
      });
    }
  };

  const handleSkipExercisePlan = (isEnabled: boolean) => {
    console.log("Skip clicked");
    setOpenRtmModal(false);
    setOpenProactiveAfterClose(true); // ONLY set when skip is clicked
    localStorage.removeItem("exercisePlan");
  };

  const handleRegisterPatient = () => {
    debugger;
    console.log("Register Patient clicked");
    setProactiveYouModal(false);
    setRegisterPatientModal(true);
  };

  const handleCloseRegistrationModal = async () => {
    setRegisterPatientModal(false);

    // Refresh patient details to get updated RTM status
    await GetPatientVisitDetails();
  };

  return (
    <>
      <IonModal
        className="overall-center-modal-main-wrap"
        backdropDismiss={false}
        isOpen={patientNotExistModal}
        placeholder={undefined}
      >
        <PatientExistModal
          setShowModal1={setPatientNotExistModal}
          actionType={ActionType.PatientDoesNotExist}
        ></PatientExistModal>
      </IonModal>

      <IonModal
        className="generic-modal-96-vw"
        backdropDismiss={false}
        isOpen={RemoteTherapeuticMonitoring}
        placeholder={undefined}
      >
        <RemoteTherapeuticMonitoringModal
          setRemoteTherapeuticMonitoring={setRemoteTherapeuticMonitoring}
          patientName={
            patientInformation?.firstName + " " + patientInformation?.lastName
          }
          onClose={handleDisableConsentClose}
        ></RemoteTherapeuticMonitoringModal>
      </IonModal>

      <IonModal
        className="generic-modal-96-vw"
        backdropDismiss={false}
        isOpen={openRtmModal}
        placeholder={undefined}
        onDidDismiss={() => {
          if (openProactiveAfterClose) {
            console.log("Opening ProactiveYou modal now...");
            setProactiveYouModal(true);
            setOpenProactiveAfterClose(false); // reset flag
          }
        }}
      >
        <RtmEnabledModal
          enabled={RtmEnabled}
          onClose={handleEnableDisableModalClose}
          onSkip={handleSkipExercisePlan}
        ></RtmEnabledModal>
      </IonModal>

      <IonModal
        className="generic-modal-96-vw"
        backdropDismiss={false}
        isOpen={proactiveYouModal}
        placeholder={undefined}
      >
        <ProactiveYouModal
          HideProactiveModal={setProactiveYouModal}
          onRegisterPatient={handleRegisterPatient}
        />
      </IonModal>

      <IonModal
        className="generic-modal-96-vw"
        backdropDismiss={false}
        isOpen={registerPatientModal}
        placeholder={undefined}
      >
        <PatientRegistrationQRModal
          setRegisterPatientModal={handleCloseRegistrationModal}
          patientData={{
            masterPatientId: Number(localStorage.getItem("masterUserId")) || 0,
            email: patientInformation?.email,
            mobilePhone: patientInformation?.mobilePhone,
            firstName: patientInformation?.firstName,
            lastName: patientInformation?.lastName,
            fullName:
              patientInformation?.firstName +
              " " +
              patientInformation?.lastName,
            patientName:
              patientInformation?.firstName +
              " " +
              patientInformation?.lastName,
            dob: patientInformation?.dob,
            DOB: patientInformation?.dob,
            FirstName: patientInformation?.firstName,
            LastName: patientInformation?.lastName,
            PatientLocationId: patientInformation?.patientLocationId,
          }}
          isCalledAfterRtmEnabled={true}
          onError={(message) => {
            setErrorMessage(message);
          }}
        />
      </IonModal>

      <IonModal
        className="generic-modal-96-vw"
        backdropDismiss={false}
        isOpen={CompletedEducation}
        placeholder={undefined}
      >
        <CompletedEducationModal
          setCompletedEducation={setCompletedEducation}
          patientName={
            patientInformation?.firstName + " " + patientInformation?.lastName
          }
          onClose={handleEducationClose}
        ></CompletedEducationModal>
      </IonModal>

      <IonModal
        backdropDismiss={false}
        className="consent-form-modal-wrap"
        isOpen={ConsentForm}
        placeholder={undefined}
      >
        <ConsentFormModal
          setConsentForm={setConsentForm}
          patientName={
            patientInformation?.firstName + " " + patientInformation?.lastName
          }
          phoneNumber={patientInformation?.mobilePhone ?? ""}
          email={patientInformation?.email ?? ""}
          onClose={handleConsentClose}
          consentFormObjectPassToParent={handleConsentFormObject}
        ></ConsentFormModal>
      </IonModal>

      <IonModal
        className="generic-modal-96-vw"
        backdropDismiss={false}
        isOpen={SetupEpisode}
        placeholder={undefined}
      >
        <SetupEpisodeModal
          setSetupEpisode={setSetupEpisode}
          consentFormData={consentFormData}
          onClose={handleSetupEpisodeClose}
          rtmStartDate={
            toValidDate(consentFormData?.StartDate)?.toLocaleDateString(
              "en-US",
            ) ?? undefined
          }
        ></SetupEpisodeModal>
      </IonModal>

      <IonModal
        className="generic-modal-96-vw"
        backdropDismiss={false}
        isOpen={NewEpisode}
        placeholder={undefined}
      >
        <NewEpisodeModal
          setNewEpisode={setNewEpisode}
          onClose={handleNewEpisodeClose}
          rtmStartDate={
            safeFormatDate(patientInformation?.rtmStartDate) || undefined
          }
        ></NewEpisodeModal>
      </IonModal>

      <IonModal
        className="generic-modal-96-vw"
        backdropDismiss={false}
        onDidDismiss={() => setChooseEpisode(false)}
        isOpen={ChooseEpisode}
        placeholder={undefined}
      >
        <ChooseEpisodeModal
          setChooseEpisode={setChooseEpisode}
          setNewEpisode={setNewEpisode}
          onClose={handleChooseEpisodeClose}
          isOpen={ChooseEpisode}
          rtmStartDate={
            safeFormatDate(patientInformation?.rtmStartDate) || undefined
          }
        ></ChooseEpisodeModal>
      </IonModal>

      <IonPage placeholder={undefined} className="page">
        <TopLeftUserName headerText={"Search"}></TopLeftUserName>
        <IonContent
          placeholder={undefined}
          className="new-patient-page slide-in-right"
        >
          <IonGrid className="container" placeholder={undefined}>
            <IonRow className="row" placeholder={undefined}>
              <IonCol className="col-sec" placeholder={undefined}>
                {errorMessage && <ErrorTopToaster errorString={errorMessage} />}
                {rtmEnabledRef.current && (
                  <div className="remote-therapeutic-card mt-24">
                    <div className="rtm-wrap d-flex justify-content-between">
                      <div className="d-flex align-items-center gap-10">
                        <IonLabel
                          className="label mb-0 fz-24"
                          placeholder={undefined}
                        >
                          Remote Therapeutic Monitoring
                        </IonLabel>
                        <input
                          type="hidden"
                          value={
                            patientInformation?.isPatientRTMEnabled
                              ? "true"
                              : "false"
                          }
                        />
                        <div
                          className={`rtm-checkbox-wrap disabled ${
                            patientInformation?.isPatientRTMEnabled
                              ? "enabled"
                              : "disabled"
                          }`}
                        >
                          {patientInformation?.isPatientRTMEnabled
                            ? "Enabled"
                            : "Disabled"}
                        </div>
                      </div>
                      {(!patientInformation?.isSFTPEhrImportEnabled ||
                        patientInformation?.externalPatientId !== 0) && (
                        <IonButton
                          placeholder={undefined}
                          type="button"
                          className="generic-btn-outline mb-0"
                          onClick={handleRtmToggle}
                        >
                          {patientInformation?.isPatientRTMEnabled
                            ? "Disable RTM"
                            : "Enable RTM"}
                        </IonButton>
                      )}
                    </div>
                  </div>
                )}

                <div
                  className="admitted-sec d-flex justify-content-between align-items-center"
                  onClick={() => {
                    if (!isAlreadyClicked) {
                      setIsAlreadyClicked(true);
                      GetPatientDetails();
                    }
                  }}
                >
                  <div className="left-sec">
                    <ul>
                      {patientSummariesList.length > 0 && (
                        <li className="gray-clr">
                          Admitted:{" "}
                          {patientSummariesList.slice(-1).map((r: any) => {
                            return safeFormatDate(r?.testDateTime);
                          })}
                        </li>
                      )}
                      {patientInformation !== undefined && (
                        <>
                          <li className="main-title">
                            {patientInformation?.firstName +
                              " " +
                              patientInformation?.lastName}
                          </li>
                          <li>
                            <span>
                              <strong>{patientInformation?.age}</strong> DOB:{" "}
                              {safeFormatDate(patientInformation?.dob)}
                            </span>
                          </li>
                        </>
                      )}
                    </ul>
                  </div>
                  <div className="right-sec">
                    <svg
                      width="30"
                      height="30"
                      viewBox="0 0 30 30"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9.22233 13.5555C9.22233 10.3646 11.8091 7.77776 15.0001 7.77776C18.1911 7.77776 20.7779 10.3646 20.7779 13.5555C20.7779 16.7465 18.1911 19.3333 15.0001 19.3333C11.8091 19.3333 9.22233 16.7465 9.22233 13.5555Z"
                        fill="#802392"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M0.555664 15C0.555664 7.02254 7.02266 0.555542 15.0001 0.555542C22.9776 0.555542 29.4446 7.02254 29.4446 15C29.4446 22.9774 22.9776 29.4444 15.0001 29.4444C7.02266 29.4444 0.555664 22.9774 0.555664 15ZM15.0001 3.44443C8.61815 3.44443 3.44455 8.61803 3.44455 15C3.44455 18.4513 4.9576 21.5492 7.35657 23.6666C9.3926 21.87 12.0694 20.7778 14.9999 20.7778C17.9305 20.7778 20.6074 21.87 22.6434 23.6668C25.0425 21.5494 26.5557 18.4514 26.5557 15C26.5557 8.61803 21.3821 3.44443 15.0001 3.44443Z"
                        fill="#802392"
                      />
                    </svg>
                  </div>
                </div>

                {loading &&
                  (lastAssessmentSummary ? (
                    lastAssessmentSummary.vbTestLookupId ==
                    TestType.five_x_sit_stand ? (
                      currentFallRisk && !isEmpty(currentFallRisk) ? (
                        <div className="admitted-sec d-flex justify-content-between align-items-center">
                          <div className="left-sec">
                            <ul>
                              <li>Mobility Level</li>
                              <li className="main-title">
                                <span className="mobility-levels">
                                  {currentFallRisk.mobility &&
                                  currentFallRisk.mobility == "ultralow"
                                    ? "LOW"
                                    : currentFallRisk?.mobility?.toUpperCase()}
                                </span>
                              </li>
                              <li>
                                <span>
                                  Last Assessed <strong>{days} days</strong> ago
                                </span>
                              </li>
                              <li>
                                <span>
                                  Last Assessment Performed{" "}
                                  <strong>
                                    {lastAssessmentSummary.testName}
                                  </strong>
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      ) : (
                        <div className="admitted-sec no-data d-flex justify-content-between align-items-center">
                          <div className="left-sec">
                            <ul>
                              <li>Current Mobility Level</li>
                              <li className="main-title">None</li>
                            </ul>
                          </div>
                          <div className="right-sec">
                            <div className="fall-risk-percentage">
                              <h3>No Test</h3>
                            </div>
                          </div>
                        </div>
                      )
                    ) : lastAssessmentSummary.vbTestLookupId ==
                      TestType.upper_body_arom ? (
                      <div className="admitted-sec d-flex justify-content-between align-items-center">
                        <div className="left-sec">
                          <ul>
                            <li>Mobility Level</li>
                            <li className="main-title">
                              <span className="mobility-levels">None</span>
                            </li>
                            <li>
                              <span>
                                Last Assessed <strong>{days} days</strong> ago
                              </span>
                            </li>
                            <li>
                              <span>
                                Last Assessment Performed{" "}
                                <strong>
                                  {lastAssessmentSummary.testName}
                                </strong>
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    ) : lastAssessmentSummary.vbTestLookupId == TestType.tug ? (
                      currentFallRisk && !isEmpty(currentFallRisk) ? (
                        <div className="admitted-sec d-flex justify-content-between align-items-center">
                          <div className="left-sec">
                            <ul>
                              <li>Mobility Level</li>
                              <li className="main-title">
                                <span className="mobility-levels">
                                  {currentFallRisk.mobility &&
                                  currentFallRisk.mobility == "ultralow"
                                    ? "LOW"
                                    : currentFallRisk?.mobility?.toUpperCase()}
                                </span>
                              </li>
                              <li>
                                <span>
                                  Last Assessed <strong>{days} days</strong> ago
                                </span>
                              </li>
                              <li>
                                <span>
                                  Last Assessment Performed{" "}
                                  <strong>
                                    {lastAssessmentSummary.testName}
                                  </strong>
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      ) : (
                        <div className="admitted-sec no-data d-flex justify-content-between align-items-center">
                          <div className="left-sec">
                            <ul>
                              <li>Current Mobility Level</li>
                              <li className="main-title">None</li>
                            </ul>
                          </div>
                          <div className="right-sec">
                            <div className="fall-risk-percentage">
                              <h3>No Test</h3>
                            </div>
                          </div>
                        </div>
                      )
                    ) : lastAssessmentSummary.vbTestLookupId ==
                      TestType.reach ? (
                      currentFallRisk && !isEmpty(currentFallRisk) ? (
                        <div className="admitted-sec d-flex justify-content-between align-items-center">
                          <div className="left-sec">
                            <ul>
                              <li>Mobility Level</li>
                              <li className="main-title">
                                <span className="mobility-levels">
                                  {currentFallRisk.mobility &&
                                  currentFallRisk.mobility == "ultralow"
                                    ? "LOW"
                                    : currentFallRisk?.mobility?.toUpperCase()}
                                </span>
                              </li>
                              <li>
                                <span>
                                  Last Assessed <strong>{days} days</strong> ago
                                </span>
                              </li>
                              <li>
                                <span>
                                  Last Assessment Performed{" "}
                                  <strong>
                                    {lastAssessmentSummary.testName}
                                  </strong>
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      ) : (
                        <div className="admitted-sec no-data d-flex justify-content-between align-items-center">
                          <div className="left-sec">
                            <ul>
                              <li>Current Mobility Level</li>
                              <li className="main-title">None</li>
                            </ul>
                          </div>
                          <div className="right-sec">
                            <div className="fall-risk-percentage">
                              <h3>No Test</h3>
                            </div>
                          </div>
                        </div>
                      )
                    ) : lastAssessmentSummary.vbTestLookupId ===
                        TestType.gait && patientAge >= 70 ? (
                      currentFallRisk && !isEmpty(currentFallRisk) ? (
                        <div className="admitted-sec d-flex justify-content-between align-items-center">
                          <div className="left-sec">
                            <ul>
                              <li>Mobility Level</li>
                              <li className="main-title">
                                <span className="mobility-levels">
                                  {currentFallRisk?.mobility
                                    ? currentFallRisk?.mobility == "ultralow"
                                      ? "LOW"
                                      : currentFallRisk?.mobility?.toUpperCase()
                                    : getRiskLevel(currentFallRisk.gaitSpeed)}
                                </span>
                              </li>
                              <li>
                                <span>
                                  Last Assessed <strong>{days} days</strong> ago
                                </span>
                              </li>
                              <li>
                                <span>
                                  Last Assessment Performed{" "}
                                  <strong>
                                    {lastAssessmentSummary.testName}
                                  </strong>
                                </span>
                              </li>
                            </ul>
                          </div>
                          <div className="right-sec">
                            {lastAssessmentSummary.vbTestLookupId ==
                              TestType.gait &&
                              currentFallRisk &&
                              !isEmpty(currentFallRisk) && (
                                <div
                                  className="fall-risk-percentage"
                                  style={{
                                    backgroundColor: getValueColor(
                                      currentFallRisk?.color,
                                    ),
                                  }}
                                >
                                  <span>FALL RISK</span>
                                  <h3>
                                    {currentFallRisk?.calculatedValue == 0
                                      ? !currentFallRisk ||
                                        currentFallRisk?.gaitSpeed == 0
                                        ? "No Test"
                                        : Math.round(
                                            GetGaitFallRisk(
                                              convertUnit(
                                                currentFallRisk.gaitSpeed,
                                                ConversionRequired.MeterToCentiMeter,
                                              ),
                                            ),
                                          ) + "%"
                                      : Math.round(
                                          currentFallRisk?.calculatedValue,
                                        ) + "%"}
                                  </h3>
                                </div>
                              )}
                          </div>
                        </div>
                      ) : (
                        <div className="admitted-sec no-data d-flex justify-content-between align-items-center">
                          <div className="left-sec">
                            <ul>
                              <li>Current Mobility Level</li>
                              <li className="main-title">None</li>
                            </ul>
                          </div>
                          <div className="right-sec">
                            <div className="fall-risk-percentage">
                              <h3>No Test</h3>
                            </div>
                          </div>
                        </div>
                      )
                    ) : (
                      lastAssessmentSummary.vbTestLookupId === TestType.gait &&
                      currentFallRisk &&
                      !isEmpty(currentFallRisk) && (
                        <div className="admitted-sec d-flex justify-content-between align-items-center">
                          <div className="left-sec">
                            <ul>
                              <li>Mobility Level</li>
                              <li className="main-title">
                                <span className="mobility-levels">
                                  {currentFallRisk?.mobility
                                    ? currentFallRisk?.mobility == "ultralow"
                                      ? "LOW"
                                      : currentFallRisk?.mobility?.toUpperCase()
                                    : getRiskLevel(currentFallRisk.gaitSpeed)}
                                </span>
                              </li>
                              <li>
                                <span className="gray-clr">
                                  Last Assessed <strong>{days} days</strong> ago
                                </span>
                              </li>
                              <li>
                                <span className="gray-clr">
                                  Last Assessment Performed{" "}
                                  <strong>
                                    {lastAssessmentSummary.testName}
                                  </strong>{" "}
                                </span>
                              </li>
                            </ul>
                          </div>
                          <div className="right-sec">
                            <div
                              className="fall-risk-percentage"
                              style={{
                                backgroundColor: getValueColor(
                                  currentFallRisk?.color,
                                ),
                              }}
                            >
                              <span>
                                {currentFallRisk?.gaitSpeed ? "GAIT SPEED" : ""}
                              </span>
                              <h3 className="less-70">
                                {currentFallRisk?.gaitSpeed
                                  ? currentFallRisk?.gaitSpeed + "m/s"
                                  : "No Test"}
                              </h3>
                            </div>
                          </div>
                        </div>
                      )
                    )
                  ) : patientSummariesList.length != 0 ? (
                    <div className="admitted-sec d-flex justify-content-between align-items-center">
                      <div className="left-sec">
                        <ul>
                          <li>
                            <span className="mobility-levels">
                              No assessment has been performed.
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  ) : (
                    <div className="no-assesment-training ">
                      <h6>No assessments or trainings have been performed.</h6>
                    </div>
                  ))}
              </IonCol>
            </IonRow>
          </IonGrid>
          {loading ? (
            patientSummariesList != undefined &&
            patientSummariesList.length > 0 ? (
              <IonGrid
                className="container patient-page-inner-sec-wrap"
                placeholder={undefined}
              >
                <IonRow className="row" placeholder={undefined}>
                  <IonCol className="col-sec" placeholder={undefined}>
                    <div className="summary-sec">
                      <h3>Recent Visits</h3>
                      <div className="slider-sec-wrap">
                        {patientSummariesList != undefined &&
                        patientSummariesList.length ? (
                          <PatientSlider
                            assesements={patientSummariesList}
                            patientVisitsCount={patientVisitsCount}
                          ></PatientSlider>
                        ) : (
                          <span>No Previous Tests Performed</span>
                        )}
                      </div>
                    </div>
                    <div
                      className={`patient-information ${
                        patientSummariesList?.length <= 0 && "no-test-perform"
                      } `}
                    ></div>
                    <div className="summary-sec mb-24 assessment-dropdown-sec">
                      <h3 className="mb-24">Trend Lines</h3>
                      <div className=" mb-8">
                        <label className="assessment-label">Metric</label>
                      </div>

                      <div ref={elementRef} className="assessment-dropdown">
                        <div
                          className="assessment-dropdown-toggle"
                          onClick={toggleDropdown}
                        >
                          {selectedItem?.name || "Select an option"}
                          <span className="arrow">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="12"
                              viewBox="0 0 16 12"
                              fill="none"
                            >
                              <path
                                d="M9.52951 10.4361C8.82176 11.3188 7.47863 11.3188 6.77088 10.4361L0.885235 3.09629C-0.0427722 1.93899 0.78113 0.222248 2.26455 0.222249L14.0358 0.22225C15.5193 0.22225 16.3432 1.93899 15.4152 3.09629L9.52951 10.4361Z"
                                fill="#707070"
                              />
                            </svg>
                          </span>
                        </div>
                        {isDropdownOpen && (
                          <div className="assessment-dropdown-menu">
                            <div className="search-field-wrap">
                              <input
                                type="text"
                                className="search-field"
                                placeholder="Search for metric"
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                              />
                            </div>
                            <div className="assessment-scroll">
                              {filteredMetrics.length > 0 ? (
                                filteredMetrics.map((metric) => (
                                  <div
                                    className="assessment-dropdown-item"
                                    key={metric.id}
                                    onClick={() => selectDropdownItem(metric)}
                                  >
                                    <h6 className="assessment-name">
                                      {metric.name}
                                    </h6>
                                    <h6 className="assessment-title">
                                      {getAssessmentTypeName(
                                        metric.lookupTypeId,
                                      )}
                                    </h6>
                                  </div>
                                ))
                              ) : (
                                <div className="no-results">
                                  No metrics found
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="separator-line"> </div>
                    </div>

                    <div>
                      {selectedItem?.lookupTypeId === TestType.gait && (
                        <h3>Gait Assessment</h3>
                      )}
                      {selectedItem?.lookupTypeId ===
                        TestType.five_x_sit_stand && <h3>5XSTS Assessment</h3>}
                      {selectedItem?.lookupTypeId ===
                        TestType.upper_body_arom && (
                        <h3>Upper Body AROM Assessment</h3>
                      )}
                      {selectedItem?.lookupTypeId ===
                        TestType.red_light_green_light && (
                        <h3>RLGL Training</h3>
                      )}
                      {selectedItem?.lookupTypeId === TestType.hec_training && (
                        <h3>Balloon Popper Training</h3>
                      )}
                      {selectedItem?.lookupTypeId === TestType.game_AF && (
                        <h3>Apple Frenzy Training</h3>
                      )}
                      {selectedItem?.lookupTypeId === TestType.reach && (
                        <h3>Functional Reach Assessment</h3>
                      )}
                      {selectedItem?.lookupTypeId === TestType.tug && (
                        <h3>TUG Assessment</h3>
                      )}
                      {selectedItem?.lookupTypeId === TestType.ctsib && (
                        <h3>mCTSIB Assessment</h3>
                      )}

                      {trendlinePlotGaitData?.gaitGraphData?.RangeIds?.length >
                        0 &&
                      trendlinePlotGaitData?.gaitGraphData?.lineGraphValues
                        ?.length > 0 ? (
                        <>
                          <div className="cutom-graph-wrap">
                            <div className="cutom-graph-wrap-header">
                              <div className="left-sec">
                                <div className="svg-icon">
                                  <TrendLineGraphSvg
                                    testLookupId={TestType.gait}
                                    metricFilter={currentMetric}
                                  ></TrendLineGraphSvg>
                                </div>
                                <div className="text-area">
                                  <h6 className="mb-0">
                                    {currentMetric === 1
                                      ? "Gait Speed"
                                      : currentMetric === 2
                                        ? "Gait Mobility"
                                        : ""}
                                  </h6>
                                </div>
                              </div>
                            </div>
                            <div className="text-area ">
                              <h6 className="mb-0 slate-gray text-right">
                                {currentMetric === 1
                                  ? "Meters / Second"
                                  : currentMetric === 2
                                    ? ""
                                    : ""}
                              </h6>
                            </div>
                            <TrendlineGraph
                              graphDetails={trendlinePlotGaitData.gaitGraphData}
                              setSelectedIndex={setGaitSelectedIndex}
                              setIsGraphClicked={setIsGaitClicked}
                              circleClicked={callGaitApiAgain}
                              yMappings={yMappings}
                            ></TrendlineGraph>
                          </div>
                        </>
                      ) : (
                        isGaitGraphSet &&
                        selectedItem?.lookupTypeId === TestType.gait && (
                          <div className="admitted-sec d-flex justify-content-center align-items-center">
                            <h6 className="generic-info-heading dark-slate-gray fw-600">
                              No assessment has been performed.
                            </h6>
                          </div>
                        )
                      )}

                      {patientSummariesList != undefined &&
                        patientSummariesList.length > 0 && (
                          // trendlinePlotGaitData?.gaitGraphData?.length > 0 && (
                          <AssessmentInfoTable
                            tableData={trendlinePlotGaitData.gaitTableData}
                            assessements={GaitGraphValuesForReport}
                            show={true}
                            lookupid={TestType.gait}
                          ></AssessmentInfoTable>
                        )}

                      {trendlinePlotAROMData?.aromGraphData?.RangeIds?.length >
                        0 &&
                      trendlinePlotAROMData?.aromGraphData?.lineGraphValues
                        ?.length > 0 ? (
                        <>
                          <div className="cutom-graph-wrap">
                            <div className="cutom-graph-wrap-header">
                              <div className="left-sec">
                                <div className="svg-icon">
                                  <TrendLineGraphSvg
                                    testLookupId={TestType.upper_body_arom}
                                    metricFilter={currentMetric}
                                  ></TrendLineGraphSvg>
                                </div>
                                <div className="text-area">
                                  <h6>
                                    {currentMetric === 1
                                      ? "Upper Body AROM Shoulder Abduction and Adduction"
                                      : currentMetric === 2
                                        ? "Upper Body AROM Shoulder Flexion and Extension"
                                        : currentMetric === 3
                                          ? "Upper Body AROM Elbow Flexion and Extension"
                                          : currentMetric === 4
                                            ? "Upper Body AROM External and Internal Rotation"
                                            : ""}
                                  </h6>
                                </div>
                              </div>
                            </div>
                            <div className="text-area">
                              <div className="d-flex justify-content-end gap-8">
                                <div className="aram-wrap">
                                  <span className="circle blue"></span>Left Arm
                                </div>
                                <div className="aram-wrap">
                                  <span className="circle red"></span>Right Arm
                                </div>
                                <h6 className="aram-wrap">Degree</h6>
                              </div>
                            </div>
                            <CustomFloatingBarGraph
                              graphDetails={trendlinePlotAROMData.aromGraphData}
                              setSelectedIndex={setAROMSelectedIndex}
                              setIsGraphClicked={setIsAROMClicked}
                              circleClicked={callAROMApiAgain}
                            ></CustomFloatingBarGraph>
                          </div>
                        </>
                      ) : (
                        isAROMGraphSet &&
                        selectedItem?.lookupTypeId ===
                          TestType.upper_body_arom && (
                          <div className="admitted-sec d-flex justify-content-center align-items-center">
                            <h6 className="generic-info-heading dark-slate-gray fw-600">
                              No assessment has been performed.
                            </h6>
                          </div>
                        )
                      )}
                      {patientSummariesList !== undefined &&
                        patientSummariesList.length > 0 && (
                          <AssessmentInfoTable
                            tableData={trendlinePlotAROMData.aromTableData}
                            assessements={aromGraphValuesForReport}
                            show={true}
                            lookupid={TestType.upper_body_arom}
                          ></AssessmentInfoTable>
                        )}

                      {trendlinePlot5xData?.sitStandGraphData?.RangeIds
                        ?.length > 0 &&
                      trendlinePlot5xData?.sitStandGraphData?.lineGraphValues
                        ?.length > 0 ? (
                        <>
                          <div className="cutom-graph-wrap">
                            <div className="cutom-graph-wrap-header">
                              <div className="left-sec">
                                <div className="svg-icon">
                                  <TrendLineGraphSvg
                                    testLookupId={TestType.five_x_sit_stand}
                                    metricFilter={currentMetric}
                                  ></TrendLineGraphSvg>
                                </div>
                                <div className="text-area">
                                  <h6>5XSTS TIME</h6>
                                </div>
                              </div>
                            </div>
                            <div className="right-sec">
                              <h6 className="mb-0 slate-gray text-right">
                                Seconds
                              </h6>
                            </div>
                            <TrendlineGraph
                              graphDetails={
                                trendlinePlot5xData.sitStandGraphData
                              }
                              setSelectedIndex={set5xSelectedIndex}
                              setIsGraphClicked={setIs5xClicked}
                              circleClicked={call5xApiAgain}
                              yMappings={yMappings}
                            ></TrendlineGraph>
                          </div>
                        </>
                      ) : (
                        is5xGraphSet &&
                        selectedItem?.lookupTypeId ===
                          TestType.five_x_sit_stand && (
                          <div className="admitted-sec d-flex justify-content-center align-items-center">
                            <h6 className="generic-info-heading dark-slate-gray fw-600">
                              No assessment has been performed.
                            </h6>
                          </div>
                        )
                      )}
                      {patientSummariesList != undefined &&
                        patientSummariesList.length > 0 &&
                        trendlinePlot5xData?.sitStandTableData?.length > 0 && (
                          <AssessmentInfoTable
                            tableData={trendlinePlot5xData.sitStandTableData}
                            assessements={XGraphValuesForReport}
                            show={true}
                            lookupid={TestType.five_x_sit_stand}
                          ></AssessmentInfoTable>
                        )}

                      {trendlinePlotRLGLData?.rlglGraphData?.RangeIds?.length >
                        0 &&
                      trendlinePlotRLGLData?.rlglGraphData?.lineGraphValues
                        ?.length > 0 ? (
                        <>
                          <div className="cutom-graph-wrap">
                            <div className="cutom-graph-wrap-header">
                              <div className="left-sec">
                                <div className="svg-icon">
                                  <TrendLineGraphSvg
                                    testLookupId={
                                      TestType.red_light_green_light
                                    }
                                    metricFilter={currentMetric}
                                  ></TrendLineGraphSvg>
                                </div>
                                <div className="text-area">
                                  <h6>
                                    {currentMetric === 1
                                      ? "RLGL Red Lights Missed"
                                      : currentMetric === 2
                                        ? "RLGL Average Speed"
                                        : ""}
                                  </h6>
                                </div>
                              </div>
                            </div>
                            <div className="text-area"></div>
                            <TrendlineGraph
                              graphDetails={trendlinePlotRLGLData.rlglGraphData}
                              setSelectedIndex={setRLGLSelectedIndex}
                              setIsGraphClicked={setIsRLGLClicked}
                              circleClicked={callRLGLApiAgain}
                              yMappings={yMappings}
                            ></TrendlineGraph>
                          </div>
                        </>
                      ) : (
                        isRLGLGraphSet &&
                        selectedItem?.lookupTypeId ===
                          TestType.red_light_green_light && (
                          <div className="admitted-sec d-flex justify-content-center align-items-center">
                            <h6 className="generic-info-heading dark-slate-gray fw-600">
                              No training has been performed.
                            </h6>
                          </div>
                        )
                      )}
                      {
                        patientSummariesList != undefined &&
                          patientSummariesList.length > 0 && (
                            // trendlinePlotGaitData?.gaitGraphData?.length > 0 && (
                            <AssessmentInfoTable
                              tableData={trendlinePlotRLGLData.rlglTableData}
                              assessements={rlglGraphValuesForReport}
                              show={true}
                              lookupid={TestType.red_light_green_light}
                            ></AssessmentInfoTable>
                          )
                        //)
                      }

                      {trendlinePlotBalloonPopperData?.balloonPopperGraphData
                        ?.RangeIds?.length > 0 &&
                      trendlinePlotBalloonPopperData?.balloonPopperGraphData
                        ?.lineGraphValues?.length > 0 ? (
                        <>
                          <div className="cutom-graph-wrap">
                            <div className="cutom-graph-wrap-header">
                              <div className="left-sec">
                                <div className="svg-icon">
                                  <TrendLineGraphSvg
                                    testLookupId={TestType.hec_training}
                                    metricFilter={currentMetric}
                                  ></TrendLineGraphSvg>
                                </div>
                                <div className="text-area">
                                  <h6 className="mb-0">
                                    {currentMetric === 1
                                      ? "Score Per Minute"
                                      : currentMetric === 2
                                        ? "Average Time to Hit"
                                        : currentMetric === 3
                                          ? "Balloons Per Minute"
                                          : ""}
                                  </h6>
                                </div>
                              </div>
                            </div>
                            <div className="right-sec ballloon-matric-three">
                              <ul>
                                {currentMetric === 3 && (
                                  <>
                                    <li className="missed-balloon">
                                      <span className="circle-balloon blue"></span>
                                      <h2>Missed Balloon</h2>
                                    </li>
                                    <li className="hit-balloon">
                                      <span className="circle-balloon red"></span>
                                      <h2>Hit Balloon</h2>
                                    </li>
                                  </>
                                )}
                                <li>
                                  <h6 className="mb-0 slate-gray text-right">
                                    {currentMetric === 1
                                      ? "Score/minute"
                                      : currentMetric === 2
                                        ? "Seconds"
                                        : currentMetric === 3
                                          ? "Balloons/minute"
                                          : ""}
                                  </h6>
                                </li>
                              </ul>
                            </div>
                            <TrendlineGraph
                              graphDetails={
                                trendlinePlotBalloonPopperData.balloonPopperGraphData
                              }
                              setSelectedIndex={setBalloonPopperSelectedIndex}
                              setIsGraphClicked={setIsBalloonPopperClicked}
                              circleClicked={callBalloonPopperApiAgain}
                              yMappings={yMappings}
                              vbTestLookupId={TestType.hec_training}
                              currentMetric={currentMetric}
                            ></TrendlineGraph>
                          </div>
                        </>
                      ) : (
                        isBalloonPopperGraphSet &&
                        selectedItem?.lookupTypeId ===
                          TestType.hec_training && (
                          <div className="admitted-sec d-flex justify-content-center align-items-center">
                            <h6 className="generic-info-heading dark-slate-gray fw-600">
                              No training has been performed.
                            </h6>
                          </div>
                        )
                      )}
                      {patientSummariesList !== undefined &&
                        patientSummariesList.length > 0 &&
                        trendlinePlotBalloonPopperData?.balloonPopperTableData
                          ?.length > 0 && (
                          <AssessmentInfoTable
                            tableData={
                              trendlinePlotBalloonPopperData?.balloonPopperTableData
                            }
                            assessements={balloonPopperGraphValuesForReport}
                            show={true}
                            lookupid={TestType.hec_training}
                          ></AssessmentInfoTable>
                        )}

                      {/* Apple Frenzy Section */}
                      {selectedItem?.lookupTypeId === TestType.game_AF && (
                        <div>
                          <div className="assesment-page-tab-btn custom-apple-frenzy-tab">
                            <button
                              className={`assesment-btn ${
                                activeTab === "lean" ? "active" : ""
                              }`}
                              onClick={() => {
                                setActiveTab("lean");
                                changeAppleFrenzyMode(1);
                              }}
                            >
                              <svg
                                width="15"
                                height="25"
                                viewBox="0 0 15 25"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M6.06069 5.65101C7.39255 4.93901 8.99316 4.97404 10.2807 5.74668L11.4153 6.42756C12.7028 7.20022 13.4863 8.59608 13.4839 10.1059L13.4723 15.1713C13.4713 15.9603 12.8294 16.6053 12.0425 16.6089C11.2556 16.6125 10.6161 15.9724 10.6169 15.1834L10.6192 12.6956L9.23971 14.4955V23.1492C9.23965 24.0989 8.62289 24.8662 7.85956 24.8662C7.09621 24.8662 6.47947 24.0989 6.47941 23.1492V16.2804H5.78933V23.1492C5.78927 24.0989 5.17251 24.8662 4.40918 24.8662C3.64583 24.8662 3.02909 24.0989 3.02903 23.1492V22.4425C3.01775 22.3721 3.01173 22.2999 3.01173 22.2264V12.6786H3.02229C2.98294 12.3085 3.04857 11.9233 3.23322 11.5694L4.07784 9.951L2.92615 10.5681C2.22997 10.9398 1.36428 10.6766 0.997438 9.98064C0.630641 9.28468 0.898186 8.41517 1.59429 8.04331L6.06069 5.65101Z"
                                  fill="#005A75"
                                />
                                <path
                                  d="M12.1772 0.931763C12.7289 0.792136 13.3121 0.8775 13.7984 1.16935C14.2848 1.46122 14.6345 1.93561 14.7706 2.488C14.9067 3.0404 14.8181 3.62586 14.5242 4.11521C14.2304 4.60449 13.7552 4.95783 13.2036 5.09746C12.652 5.23706 12.0687 5.1517 11.5824 4.85987C11.0961 4.56802 10.7464 4.09358 10.6102 3.54122C10.4741 2.98882 10.5628 2.40337 10.8566 1.91401C11.1505 1.42469 11.6256 1.07141 12.1772 0.931763Z"
                                  fill="#005A75"
                                />
                              </svg>
                              Lean
                            </button>

                            <button
                              className={`assesment-btn ${
                                activeTab === "hands" ? "active" : ""
                              }`}
                              onClick={() => {
                                setActiveTab("hands");
                                changeAppleFrenzyMode(2);
                              }}
                            >
                              <svg
                                width="13"
                                height="25"
                                viewBox="0 0 13 25"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M3.5188 5.36621C4.14096 5.36621 4.73764 5.12916 5.17757 4.7072C5.61751 4.28524 5.86466 3.71295 5.86466 3.11621C5.86466 2.51947 5.61751 1.94718 5.17757 1.52522C4.73764 1.10326 4.14096 0.866211 3.5188 0.866211C2.89664 0.866211 2.29996 1.10326 1.86002 1.52522C1.42009 1.94718 1.17293 2.51947 1.17293 3.11621C1.17293 3.71295 1.42009 4.28524 1.86002 4.7072C2.29996 5.12916 2.89664 5.36621 3.5188 5.36621ZM3.12782 6.86621C1.40263 6.86621 0 8.21152 0 9.86621V14.3662V14.3943V23.3662C0 24.1959 0.698872 24.8662 1.56391 24.8662C2.42895 24.8662 3.12782 24.1959 3.12782 23.3662V17.3662H3.90977V23.3662C3.90977 24.1959 4.60865 24.8662 5.47368 24.8662C6.33872 24.8662 7.03759 24.1959 7.03759 23.3662V9.77246H8.79699C9.4812 9.77246 10.1214 9.77246 10.6541 9.77246H11.2406C12.1056 9.77246 13 9.20996 13 8.36621C13 7.52246 12.3989 6.86621 11.5338 6.86621H9.87218H8.02481C6.74436 6.86621 6.06504 6.86621 4.72594 6.86621H3.12782Z"
                                  fill="#005A75"
                                />
                              </svg>
                              Hand
                            </button>

                            <button
                              className={`assesment-btn ${
                                activeTab === "lateral_step" ? "active" : ""
                              }`}
                              onClick={() => {
                                setActiveTab("lateral_step");
                                changeAppleFrenzyMode(3);
                              }}
                            >
                              <svg
                                width="16"
                                height="25"
                                viewBox="0 0 16 25"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M5.91404 3.1123C5.91404 2.5166 6.15105 1.9453 6.57294 1.52408C6.99483 1.10285 7.56703 0.866211 8.16367 0.866211C8.76031 0.866211 9.33251 1.10285 9.7544 1.52408C10.1763 1.9453 10.4133 2.5166 10.4133 3.1123C10.4133 3.708 10.1763 4.27931 9.7544 4.70053C9.33251 5.12176 8.76031 5.3584 8.16367 5.3584C7.56703 5.3584 6.99483 5.12176 6.57294 4.70053C6.15105 4.27931 5.91404 3.708 5.91404 3.1123ZM7.78873 17.3376V23.3271C7.78873 24.1554 7.11853 24.8245 6.28898 24.8245C5.45943 24.8245 4.78922 24.1554 4.78922 23.3271V12.8875L3.44882 15.1149C3.02233 15.8214 2.09904 16.0507 1.39134 15.6249C0.683646 15.1991 0.453996 14.2773 0.880489 13.5707L3.61285 9.03169C4.42835 7.67936 5.89061 6.85111 7.47004 6.85111H8.86199C10.4414 6.85111 11.9037 7.67936 12.7192 9.03169L15.4515 13.5707C15.878 14.2773 15.6484 15.1991 14.9407 15.6249C14.233 16.0507 13.3097 15.8214 12.8832 15.1149L11.5381 12.8875L11.6623 16.8384L15.5375 23.3271C15.6616 23.8263 15.5375 24.536 14.6618 24.8245C13.7861 25.1131 12.8621 23.8263 12.538 23.3271L8.53861 17.3376H7.78873Z"
                                  fill="#005A75"
                                />
                              </svg>
                              Lateral Step
                            </button>
                          </div>

                          {trendlinePlotAppleFrenzyData?.appleFrenzyGraphData
                            ?.RangeIds?.length > 0 &&
                          trendlinePlotAppleFrenzyData?.appleFrenzyGraphData
                            ?.lineGraphValues?.length > 0 ? (
                            <>
                              <div className="cutom-graph-wrap">
                                <div className="cutom-graph-wrap-header">
                                  <div className="left-sec">
                                    <div className="svg-icon">
                                      <TrendLineGraphSvg
                                        testLookupId={TestType.game_AF}
                                        metricFilter={currentMetric}
                                      />
                                    </div>
                                    <div className="text-area apple-frenzy-text">
                                      <h6 className="mb-0">
                                        Apple Percentage Caught
                                      </h6>
                                    </div>
                                  </div>
                                </div>

                                <div className="right-sec ballloon-matric-three">
                                  <ul>
                                    <li className="missed-balloon">
                                      <span className="circle-balloon blue"></span>
                                      <h2>Good Apple</h2>
                                    </li>
                                    <li className="hit-balloon">
                                      <span className="circle-balloon red"></span>
                                      <h2>Bad Apple</h2>
                                    </li>
                                    <li>
                                      <h6 className="mb-0 slate-gray text-right">
                                        Percentage
                                      </h6>
                                    </li>
                                  </ul>
                                </div>

                                <TrendlineGraph
                                  graphDetails={
                                    trendlinePlotAppleFrenzyData.appleFrenzyGraphData
                                  }
                                  setSelectedIndex={setAppleFrenzySelectedIndex}
                                  setIsGraphClicked={setIsAppleFrenzyClicked}
                                  circleClicked={callAppleFrenzyApiAgain}
                                  yMappings={yMappings}
                                  vbTestLookupId={TestType.game_AF}
                                  currentMetric={currentMetric}
                                />
                              </div>
                            </>
                          ) : (
                            isAppleFrenzyGraphSet &&
                            selectedItem?.lookupTypeId === TestType.game_AF && (
                              <div className="admitted-sec d-flex justify-content-center align-items-center no-assement-apple-frenzy">
                                <h6 className="generic-info-heading dark-slate-gray fw-600">
                                  No training has been performed.
                                </h6>
                              </div>
                            )
                          )}

                          {patientSummariesList !== undefined &&
                            patientSummariesList.length > 0 &&
                            trendlinePlotAppleFrenzyData?.appleFrenzyTableData
                              ?.length > 0 && (
                              <AssessmentInfoTable
                                tableData={
                                  trendlinePlotAppleFrenzyData?.appleFrenzyTableData
                                }
                                assessements={appleFrenzyGraphValuesForReport}
                                show={true}
                                lookupid={TestType.game_AF}
                              ></AssessmentInfoTable>
                            )}
                        </div>
                      )}

                      {/* Veggie Slicer Section */}
                      {selectedItem?.lookupTypeId ===
                        TestType.veggie_samurai && (
                        <div>
                          {trendlinePlotVeggieSlicerData?.veggieSlicerGraphData
                            ?.RangeIds?.length > 0 &&
                          trendlinePlotVeggieSlicerData?.veggieSlicerGraphData
                            ?.lineGraphValues?.length > 0 ? (
                            <>
                              <div className="cutom-graph-wrap">
                                <div className="cutom-graph-wrap-header">
                                  <div className="left-sec">
                                    <div className="svg-icon">
                                      <TrendLineGraphSvg
                                        testLookupId={TestType.veggie_samurai}
                                        metricFilter={currentMetric}
                                      />
                                    </div>
                                    <div className="text-area apple-frenzy-text">
                                      <h6 className="mb-0">
                                        {currentMetric === 1
                                          ? "Score Per Minute"
                                          : currentMetric === 2
                                            ? "Total Veggies Cut"
                                            : ""}
                                      </h6>
                                    </div>
                                  </div>
                                </div>

                                <div className="right-sec">
                                  <h6 className="mb-0 slate-gray text-right">
                                    Score/minute
                                  </h6>
                                </div>

                                <TrendlineGraph
                                  graphDetails={
                                    trendlinePlotVeggieSlicerData?.veggieSlicerGraphData
                                  }
                                  setSelectedIndex={
                                    setVeggieSlicerSelectedIndex
                                  }
                                  setIsGraphClicked={setIsVeggieSlicerClicked}
                                  circleClicked={callVeggieSlicerApiAgain}
                                  yMappings={yMappings}
                                  vbTestLookupId={TestType.veggie_samurai}
                                  currentMetric={currentMetric}
                                />
                              </div>
                            </>
                          ) : (
                            isVeggieSlicerGraphSet &&
                            selectedItem?.lookupTypeId ===
                              TestType.veggie_samurai && (
                              <div className="admitted-sec d-flex justify-content-center align-items-center no-assement-apple-frenzy">
                                <h6 className="generic-info-heading dark-slate-gray fw-600">
                                  No training has been performed.
                                </h6>
                              </div>
                            )
                          )}

                          {patientSummariesList !== undefined &&
                            patientSummariesList.length > 0 &&
                            trendlinePlotVeggieSlicerData?.veggieSlicerTableData
                              ?.length > 0 && (
                              <AssessmentInfoTable
                                tableData={
                                  trendlinePlotVeggieSlicerData?.veggieSlicerTableData
                                }
                                assessements={veggieSlicerGraphValuesForReport}
                                show={true}
                                lookupid={TestType.veggie_samurai}
                              ></AssessmentInfoTable>
                            )}
                        </div>
                      )}

                      {/* Tug Section */}
                      {selectedItem?.lookupTypeId === TestType.tug && (
                        <div>
                          {trendlinePlotTugData?.tugGraphData?.RangeIds
                            ?.length > 0 &&
                          trendlinePlotTugData?.tugGraphData?.lineGraphValues
                            ?.length > 0 ? (
                            <>
                              <div className="cutom-graph-wrap">
                                <div className="cutom-graph-wrap-header">
                                  <div className="left-sec">
                                    <div className="svg-icon">
                                      <TrendLineGraphSvg
                                        testLookupId={TestType.tug}
                                        metricFilter={currentMetric}
                                      />
                                    </div>
                                    <div className="text-area apple-frenzy-text">
                                      <h6 className="mb-0">
                                        {currentMetric === 1
                                          ? "Total Time"
                                          : ""}
                                      </h6>
                                    </div>
                                  </div>
                                </div>

                                <div className="right-sec">
                                  <h6 className="mb-0 slate-gray text-right">
                                    Meters / Second
                                  </h6>
                                </div>

                                <TrendlineGraph
                                  graphDetails={
                                    trendlinePlotTugData?.tugGraphData
                                  }
                                  setSelectedIndex={setTugSelectedIndex}
                                  setIsGraphClicked={setIsTugClicked}
                                  circleClicked={callTugApiAgain}
                                  yMappings={yMappings}
                                  vbTestLookupId={TestType.tug}
                                  currentMetric={currentMetric}
                                />
                              </div>
                            </>
                          ) : (
                            isTugGraphSet &&
                            selectedItem?.lookupTypeId === TestType.tug && (
                              <div className="admitted-sec d-flex justify-content-center align-items-center no-assement-apple-frenzy">
                                <h6 className="generic-info-heading dark-slate-gray fw-600">
                                  No assessment has been performed.
                                </h6>
                              </div>
                            )
                          )}

                          {patientSummariesList !== undefined &&
                            patientSummariesList.length > 0 &&
                            trendlinePlotTugData?.tugTableData?.length > 0 && (
                              <AssessmentInfoTable
                                tableData={trendlinePlotTugData?.tugTableData}
                                assessements={tugGraphValuesForReport}
                                show={true}
                                lookupid={TestType.tug}
                                isIncompleteAssessment={
                                  isIncompleteTugAssessment
                                }
                              ></AssessmentInfoTable>
                            )}
                        </div>
                      )}

                      {/* Functional Reach Section */}
                      {selectedItem?.lookupTypeId === TestType.reach && (
                        <div>
                          {trendlinePlotFunctionalReachData
                            ?.functionalReachGraphData?.RangeIds?.length > 0 &&
                          trendlinePlotFunctionalReachData
                            ?.functionalReachGraphData?.lineGraphValues
                            ?.length > 0 ? (
                            <>
                              <div className="cutom-graph-wrap">
                                <div className="cutom-graph-wrap-header">
                                  <div className="left-sec">
                                    <div className="svg-icon">
                                      <TrendLineGraphSvg
                                        testLookupId={TestType.reach}
                                        metricFilter={currentMetric}
                                      />
                                    </div>
                                    <div className="text-area apple-frenzy-text">
                                      <h6 className="mb-0">
                                        {currentMetric === 1
                                          ? "Forward Reach"
                                          : currentMetric === 2
                                            ? "Lateral Reach"
                                            : ""}
                                      </h6>
                                    </div>
                                  </div>
                                </div>

                                <div className="right-sec ballloon-matric-three">
                                  <ul>
                                    {currentMetric === 2 && (
                                      <>
                                        <li className="missed-balloon">
                                          <span className="circle-balloon blue"></span>
                                          <h2>Left</h2>
                                        </li>
                                        <li className="hit-balloon">
                                          <span className="circle-balloon red"></span>
                                          <h2>Right</h2>
                                        </li>
                                      </>
                                    )}
                                    <li>
                                      <h6 className="mb-0 slate-gray text-right">
                                        {currentMetric === 1 ||
                                        currentMetric === 2
                                          ? "Inches"
                                          : ""}
                                      </h6>
                                    </li>
                                  </ul>
                                </div>

                                <TrendlineGraph
                                  graphDetails={
                                    trendlinePlotFunctionalReachData?.functionalReachGraphData
                                  }
                                  setSelectedIndex={
                                    setFunctionalReachSelectedIndex
                                  }
                                  setIsGraphClicked={
                                    setIsFunctionalReachClicked
                                  }
                                  circleClicked={callFunctionalReachApiAgain}
                                  yMappings={yMappings}
                                  vbTestLookupId={TestType.reach}
                                  currentMetric={currentMetric}
                                />
                              </div>
                            </>
                          ) : (
                            isFunctionalReachGraphSet &&
                            selectedItem?.lookupTypeId === TestType.reach && (
                              <div className="admitted-sec d-flex justify-content-center align-items-center no-assement-apple-frenzy">
                                <h6 className="generic-info-heading dark-slate-gray fw-600">
                                  No assessment has been performed.
                                </h6>
                              </div>
                            )
                          )}

                          {patientSummariesList !== undefined &&
                            patientSummariesList.length > 0 &&
                            trendlinePlotFunctionalReachData
                              ?.functionalReachTableData?.length > 0 && (
                              <AssessmentInfoTable
                                tableData={
                                  trendlinePlotFunctionalReachData?.functionalReachTableData
                                }
                                assessements={
                                  functionalReachGraphValuesForReport
                                }
                                show={true}
                                lookupid={TestType.reach}
                              ></AssessmentInfoTable>
                            )}
                        </div>
                      )}
                      {/* mCTSIB Section */}
                      {selectedItem?.lookupTypeId === TestType.ctsib && (
                        <div>
                          {trendlinePlotMctsibData?.mctsibGraphData?.RangeIds
                            ?.length > 0 &&
                          trendlinePlotMctsibData?.mctsibGraphData
                            ?.lineGraphValues?.length > 0 ? (
                            <>
                              <div className="cutom-graph-wrap">
                                <div className="cutom-graph-wrap-header">
                                  <div className="left-sec">
                                    <div className="svg-icon">
                                      <TrendLineGraphSvg
                                        testLookupId={TestType.ctsib}
                                        metricFilter={currentMetric}
                                      />
                                    </div>
                                    <div className="text-area apple-frenzy-text">
                                      <h6 className="mb-0">
                                        {currentMetric === 1
                                          ? "Visual Score"
                                          : currentMetric === 2
                                            ? "Vestibular Score"
                                            : currentMetric === 3
                                              ? "Somatosensory Score"
                                              : currentMetric === 4
                                                ? "Composite Score"
                                                : ""}
                                      </h6>
                                    </div>
                                  </div>
                                </div>

                                <div className="right-sec ballloon-matric-three">
                                  <ul>
                                    <li>
                                      <h6 className="mb-0 slate-gray text-right">
                                        Inches
                                      </h6>
                                    </li>
                                  </ul>
                                </div>

                                <TrendlineGraph
                                  graphDetails={
                                    trendlinePlotMctsibData?.mctsibGraphData
                                  }
                                  setSelectedIndex={setMctsibSelectedIndex}
                                  setIsGraphClicked={setIsMctsibGraphSet}
                                  circleClicked={callMctsibApiAgain}
                                  yMappings={yMappings}
                                  vbTestLookupId={TestType.ctsib}
                                  currentMetric={currentMetric}
                                />
                              </div>
                            </>
                          ) : (
                            isMctsibGraphSet &&
                            selectedItem?.lookupTypeId === TestType.ctsib && (
                              <div className="admitted-sec d-flex justify-content-center align-items-center no-assement-apple-frenzy">
                                <h6 className="generic-info-heading dark-slate-gray fw-600">
                                  No assessment has been performed.
                                </h6>
                              </div>
                            )
                          )}

                          {patientSummariesList !== undefined &&
                            patientSummariesList.length > 0 &&
                            trendlinePlotMctsibData?.mctsibTableData?.length >
                              0 && (
                              <AssessmentInfoTable
                                tableData={
                                  trendlinePlotMctsibData?.mctsibTableData
                                }
                                assessements={mctsibGraphValuesForReport}
                                show={true}
                                lookupid={TestType.ctsib}
                              ></AssessmentInfoTable>
                            )}
                        </div>
                      )}
                    </div>
                    <div className="bottom-space-on-patient-page"></div>
                  </IonCol>
                </IonRow>
              </IonGrid>
            ) : (
              ""
            )
          ) : (
            <Loader />
          )}
        </IonContent>
        <IonFooter
          className="patient-page-footer ion-no-border"
          placeholder={undefined}
        >
          <div className="container">
            <div className="d-flex gap-20 mobile-column">
              <IonButton
                className="generic-btn-outline mb-0"
                placeholder={undefined}
                onClick={() =>
                  history.push("/full-visit-summary", {
                    patientInfo: patientInformation,
                  })
                }
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="18" height="18" fill="white" />
                  <path
                    d="M11.7555 2.84687C11.4399 4.1125 10.3024 5 8.99925 5C7.69612 5 6.55862 4.1125 6.243 2.84687L5.968 1.75625C5.83675 1.22188 5.293 0.896875 4.7555 1.03125C4.218 1.16563 3.89612 1.70625 4.0305 2.24375L4.30237 3.33437C4.64612 4.70937 5.55862 5.82188 6.74925 6.44688V16C6.74925 16.5531 7.19612 17 7.74925 17C8.30237 17 8.74925 16.5531 8.74925 16V12H9.24925V16C9.24925 16.5531 9.69612 17 10.2492 17C10.8024 17 11.2492 16.5531 11.2492 16V6.44688C12.4399 5.82188 13.3524 4.70937 13.6961 3.33437L13.968 2.24375C14.1024 1.70937 13.7774 1.16563 13.2399 1.03125C12.7024 0.896875 12.1617 1.22188 12.0305 1.75625L11.7586 2.84687H11.7555ZM8.99925 4C9.39707 4 9.7786 3.84196 10.0599 3.56066C10.3412 3.27936 10.4992 2.89782 10.4992 2.5C10.4992 2.10218 10.3412 1.72064 10.0599 1.43934C9.7786 1.15804 9.39707 1 8.99925 1C8.60142 1 8.21989 1.15804 7.93859 1.43934C7.65728 1.72064 7.49925 2.10218 7.49925 2.5C7.49925 2.89782 7.65728 3.27936 7.93859 3.56066C8.21989 3.84196 8.60142 4 8.99925 4Z"
                    fill="#005A75"
                  />
                </svg>
                Create an Exercise Plan
              </IonButton>
              <IonButton
                className="generic-btn bg-blue"
                placeholder={undefined}
                onClick={() => {
                  setcurrentAssessmentState(defaultAssessment);
                  history.push("/select-an-assessment");
                }}
              >
                <svg
                  width="11"
                  height="18"
                  viewBox="0 0 11 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="c-plus-icon"
                >
                  <path
                    d="M6.27907 3.34884C7.2 3.34884 7.95349 2.59535 7.95349 1.67442C7.95349 0.753488 7.2 0 6.27907 0C5.35814 0 4.60465 0.753488 4.60465 1.67442C4.60465 2.59535 5.35814 3.34884 6.27907 3.34884ZM3.1814 6.19535L1.03814 17.0037C0.929302 17.5144 1.33116 18 1.8586 18H1.92558C2.31907 18 2.65395 17.7321 2.74605 17.347L4.10233 11.3023L5.86047 12.9767V17.1628C5.86047 17.6233 6.23721 18 6.69767 18C7.15814 18 7.53488 17.6233 7.53488 17.1628V12.4409C7.53488 11.9805 7.3507 11.5451 7.01581 11.227L5.77674 10.0465L6.27907 7.53488C7.17488 8.57302 8.47256 9.31814 9.9293 9.55256C10.4316 9.62791 10.8837 9.22605 10.8837 8.71535C10.8837 8.30512 10.5823 7.96186 10.1721 7.89488C8.89954 7.68558 7.84465 6.93209 7.28372 5.94419L6.44651 4.60465C5.97767 3.85953 5.04 3.55814 4.22791 3.9014L1.0214 5.25767C0.40186 5.52558 0 6.12837 0 6.80651V8.7907C0 9.25116 0.376744 9.62791 0.837209 9.62791C1.29767 9.62791 1.67442 9.25116 1.67442 8.7907V6.7814L3.1814 6.19535Z"
                    fill="white"
                  />
                </svg>
                Get Started
              </IonButton>
            </div>
          </div>
        </IonFooter>
      </IonPage>
    </>
  );
};
export default PatientPage;
